import { Taf } from "@huyafed/taf-network";

/*!
 * This file was generated by jce-tools 
 */

export var GameRelease = GameRelease || {};

export var HUYA = HUYA || {};

GameRelease.GetSimpleCommentWhitTopReq = function () {
  this.tId = new GameRelease.UserId();
  this.iAppId = 0;
  this.sTopicId = "";
  this.iIndex = 0;
  this.iSize = 0;
  this.iListType = 0;
  this.topId = 0;
};

GameRelease.GetSimpleCommentWhitTopReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.iAppId = is.readInt32(1, false, this.iAppId);
  this.sTopicId = is.readString(2, false, this.sTopicId);
  this.iIndex = is.readInt32(3, false, this.iIndex);
  this.iSize = is.readInt32(4, false, this.iSize);
  this.iListType = is.readInt32(5, false, this.iListType);
  this.topId = is.readInt64(6, false, this.topId);
};

GameRelease.GetSimpleCommentWhitTopReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeInt32(1, this.iAppId);
  os.writeString(2, this.sTopicId);
  os.writeInt32(3, this.iIndex);
  os.writeInt32(4, this.iSize);
  os.writeInt32(5, this.iListType);
  os.writeInt64(6, this.topId);
};

GameRelease.GetSimpleCommentWhitTopReq.prototype._clone = function () {
  return new GameRelease.GetSimpleCommentWhitTopReq();
};
GameRelease.GetSimpleCommentWhitTopReq.prototype._write = function (
  os,
  tag,
  value
) {
  os.writeStruct(tag, value);
};
GameRelease.GetSimpleCommentWhitTopReq.prototype._read = function (
  is,
  tag,
  def
) {
  return is.readStruct(tag, true, def);
};

GameRelease.UserId = function () {
  this.lUid = 0;
  this.sGuid = "";
  this.sToken = "";
  this.sHuYaUA = "";
  this.sCookie = "";
  this.iTokenType = 0;
  this.sDeviceInfo = "";
};

GameRelease.UserId.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.sGuid = is.readString(1, false, this.sGuid);
  this.sToken = is.readString(2, false, this.sToken);
  this.sHuYaUA = is.readString(3, false, this.sHuYaUA);
  this.sCookie = is.readString(4, false, this.sCookie);
  this.iTokenType = is.readInt32(5, false, this.iTokenType);
  this.sDeviceInfo = is.readString(6, false, this.sDeviceInfo);
};

GameRelease.UserId.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid);
  os.writeString(1, this.sGuid);
  os.writeString(2, this.sToken);
  os.writeString(3, this.sHuYaUA);
  os.writeString(4, this.sCookie);
  os.writeInt32(5, this.iTokenType);
  os.writeString(6, this.sDeviceInfo);
};

GameRelease.UserId.prototype._clone = function () {
  return new GameRelease.UserId();
};
GameRelease.UserId.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.UserId.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GetSimpleCommentRsp = function () {
  this.sMessage = "";
  this.vComment = new Taf.Vector(new GameRelease.SimpleComment());
  this.iHasMore = 0;
  this.iTotal = 0;
};

GameRelease.GetSimpleCommentRsp.prototype.readFrom = function (is) {
  this.sMessage = is.readString(0, false, this.sMessage);
  this.vComment = is.readVector(1, false, this.vComment);
  this.iHasMore = is.readInt32(2, false, this.iHasMore);
  this.iTotal = is.readInt64(3, false, this.iTotal);
};

GameRelease.GetSimpleCommentRsp.prototype.writeTo = function (os) {
  os.writeString(0, this.sMessage);
  os.writeVector(1, this.vComment);
  os.writeInt32(2, this.iHasMore);
  os.writeInt64(3, this.iTotal);
};

GameRelease.GetSimpleCommentRsp.prototype._clone = function () {
  return new GameRelease.GetSimpleCommentRsp();
};
GameRelease.GetSimpleCommentRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GetSimpleCommentRsp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.SimpleComment = function () {
  this.lCommentId = 0;
  this.lParentId = 0;
  this.lUid = 0;
  this.sNickName = "";
  this.sAvatar = "";
  this.sContent = "";
  this.iLikeCount = 0;
  this.iShareCount = 0;
  this.iStatus = 0;
  this.lTime = 0;
  this.iSubCommentCount = 0;
  this.vSubComment = new Taf.Vector(GameRelease.SimpleComment);
  this.vTag = new Taf.Vector(new GameRelease.CommentTag());
  this.lReplyToComId = 0;
  this.lReplyToUid = 0;
  this.sReplyToNickName = "";
  this.iOnwerOpt = 0;
  this.iOpt = 0;
};

GameRelease.SimpleComment.prototype.readFrom = function (is) {
  this.lCommentId = is.readInt64(0, false, this.lCommentId);
  this.lParentId = is.readInt64(1, false, this.lParentId);
  this.lUid = is.readInt64(2, false, this.lUid);
  this.sNickName = is.readString(3, false, this.sNickName);
  this.sAvatar = is.readString(4, false, this.sAvatar);
  this.sContent = is.readString(5, false, this.sContent);
  this.iLikeCount = is.readInt32(6, false, this.iLikeCount);
  this.iShareCount = is.readInt32(7, false, this.iShareCount);
  this.iStatus = is.readInt32(8, false, this.iStatus);
  this.lTime = is.readInt64(9, false, this.lTime);
  this.iSubCommentCount = is.readInt32(10, false, this.iSubCommentCount);
  this.vSubComment = is.readVector(11, false, this.vSubComment);
  this.vTag = is.readVector(12, false, this.vTag);
  this.lReplyToComId = is.readInt64(13, false, this.lReplyToComId);
  this.lReplyToUid = is.readInt64(14, false, this.lReplyToUid);
  this.sReplyToNickName = is.readString(15, false, this.sReplyToNickName);
  this.iOnwerOpt = is.readInt32(16, false, this.iOnwerOpt);
  this.iOpt = is.readInt32(17, false, this.iOpt);
};

GameRelease.SimpleComment.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lCommentId);
  os.writeInt64(1, this.lParentId);
  os.writeInt64(2, this.lUid);
  os.writeString(3, this.sNickName);
  os.writeString(4, this.sAvatar);
  os.writeString(5, this.sContent);
  os.writeInt32(6, this.iLikeCount);
  os.writeInt32(7, this.iShareCount);
  os.writeInt32(8, this.iStatus);
  os.writeInt64(9, this.lTime);
  os.writeInt32(10, this.iSubCommentCount);
  os.writeVector(11, this.vSubComment);
  os.writeVector(12, this.vTag);
  os.writeInt64(13, this.lReplyToComId);
  os.writeInt64(14, this.lReplyToUid);
  os.writeString(15, this.sReplyToNickName);
  os.writeInt32(16, this.iOnwerOpt);
  os.writeInt32(17, this.iOpt);
};

GameRelease.SimpleComment.prototype._clone = function () {
  return new GameRelease.SimpleComment();
};
GameRelease.SimpleComment.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.SimpleComment.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.CommentTag = function () {
  this.iTagId = 0;
  this.vCommentAttach = new Taf.Vector(new GameRelease.CommentAttach());
};

GameRelease.CommentTag.prototype.readFrom = function (is) {
  this.iTagId = is.readInt32(0, false, this.iTagId);
  this.vCommentAttach = is.readVector(1, false, this.vCommentAttach);
};

GameRelease.CommentTag.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iTagId);
  os.writeVector(1, this.vCommentAttach);
};

GameRelease.CommentTag.prototype._clone = function () {
  return new GameRelease.CommentTag();
};
GameRelease.CommentTag.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.CommentTag.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.CommentAttach = function () {
  this.iType = 0;
  this.sContent = "";
  this.sFileMD5 = "";
};

GameRelease.CommentAttach.prototype.readFrom = function (is) {
  this.iType = is.readInt32(0, false, this.iType);
  this.sContent = is.readString(1, false, this.sContent);
  this.sFileMD5 = is.readString(2, false, this.sFileMD5);
};

GameRelease.CommentAttach.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iType);
  os.writeString(1, this.sContent);
  os.writeString(2, this.sFileMD5);
};

GameRelease.CommentAttach.prototype._clone = function () {
  return new GameRelease.CommentAttach();
};
GameRelease.CommentAttach.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.CommentAttach.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GetGameCouponInfoReq = function () {
  this.tId = new HUYA.UserId();
  this.gameId = 0;
  this.couponUUIDs = new Taf.Vector(new Taf.STRING());
  this.from = "";
};

GameRelease.GetGameCouponInfoReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.gameId = is.readInt32(1, false, this.gameId);
  this.couponUUIDs = is.readVector(2, false, this.couponUUIDs);
  this.from = is.readString(3, false, this.from);
};

GameRelease.GetGameCouponInfoReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeInt32(1, this.gameId);
  os.writeVector(2, this.couponUUIDs);
  os.writeString(3, this.from);
};

GameRelease.GetGameCouponInfoReq.prototype._clone = function () {
  return new GameRelease.GetGameCouponInfoReq();
};
GameRelease.GetGameCouponInfoReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GetGameCouponInfoReq.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.UserId = function () {
  this.lUid = 0;
  this.sGuid = "";
  this.sToken = "";
  this.sHuYaUA = "";
  this.sCookie = "";
  this.iTokenType = 0;
  this.sDeviceInfo = "";
  this.sQIMEI = "";
};

HUYA.UserId.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.sGuid = is.readString(1, false, this.sGuid);
  this.sToken = is.readString(2, false, this.sToken);
  this.sHuYaUA = is.readString(3, false, this.sHuYaUA);
  this.sCookie = is.readString(4, false, this.sCookie);
  this.iTokenType = is.readInt32(5, false, this.iTokenType);
  this.sDeviceInfo = is.readString(6, false, this.sDeviceInfo);
  this.sQIMEI = is.readString(7, false, this.sQIMEI);
};

HUYA.UserId.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid);
  os.writeString(1, this.sGuid);
  os.writeString(2, this.sToken);
  os.writeString(3, this.sHuYaUA);
  os.writeString(4, this.sCookie);
  os.writeInt32(5, this.iTokenType);
  os.writeString(6, this.sDeviceInfo);
  os.writeString(7, this.sQIMEI);
};

HUYA.UserId.prototype._clone = function () {
  return new HUYA.UserId();
};
HUYA.UserId.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.UserId.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GetGameCouponInfoRsp = function () {
  this.response = new GameRelease.GameCeterResponse();
  this.coupons = new Taf.Vector(new GameRelease.GameCoupon());
  this.canReceivedCount = 0;
};

GameRelease.GetGameCouponInfoRsp.prototype.readFrom = function (is) {
  this.response = is.readStruct(0, false, this.response);
  this.coupons = is.readVector(1, false, this.coupons);
  this.canReceivedCount = is.readInt32(2, false, this.canReceivedCount);
};

GameRelease.GetGameCouponInfoRsp.prototype.writeTo = function (os) {
  os.writeStruct(0, this.response);
  os.writeVector(1, this.coupons);
  os.writeInt32(2, this.canReceivedCount);
};

GameRelease.GetGameCouponInfoRsp.prototype._clone = function () {
  return new GameRelease.GetGameCouponInfoRsp();
};
GameRelease.GetGameCouponInfoRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GetGameCouponInfoRsp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GameCeterResponse = function () {
  this.res = 0;
  this.msg = "";
};

GameRelease.GameCeterResponse.prototype.readFrom = function (is) {
  this.res = is.readInt32(0, false, this.res);
  this.msg = is.readString(1, false, this.msg);
};

GameRelease.GameCeterResponse.prototype.writeTo = function (os) {
  os.writeInt32(0, this.res);
  os.writeString(1, this.msg);
};

GameRelease.GameCeterResponse.prototype._clone = function () {
  return new GameRelease.GameCeterResponse();
};
GameRelease.GameCeterResponse.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GameCeterResponse.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GameCoupon = function () {
  this.couponId = 0;
  this.recordId = 0;
  this.gameId = 0;
  this.couponName = "";
  this.couponDesc = "";
  this.couponUsePreCondition = "";
  this.couponUuid = "";
  this.couponCode = "";
  this.serial = "";
  this.couponType = 0;
  this.couponMinPrice = 0;
  this.couponFavour = 0;
  this.winTime = 0;
  this.startTime = 0;
  this.endTime = 0;
  this.effectiveStartTime = 0;
  this.effectiveEndTime = 0;
  this.useStatus = 0;
  this.ifCanUse = 0;
  this.location = "";
  this.totalCount = 0;
  this.leavingCount = 0;
  this.useLifespane = 0;
  this.gameName = "";
  this.canotUseReason = "";
  this.couponUsePreConditionDesc = "";
};

GameRelease.GameCoupon.prototype.readFrom = function (is) {
  this.couponId = is.readInt64(0, false, this.couponId);
  this.recordId = is.readInt64(1, false, this.recordId);
  this.gameId = is.readInt32(2, false, this.gameId);
  this.couponName = is.readString(3, false, this.couponName);
  this.couponDesc = is.readString(4, false, this.couponDesc);
  this.couponUsePreCondition = is.readString(
    5,
    false,
    this.couponUsePreCondition
  );
  this.couponUuid = is.readString(6, false, this.couponUuid);
  this.couponCode = is.readString(7, false, this.couponCode);
  this.serial = is.readString(8, false, this.serial);
  this.couponType = is.readInt32(9, false, this.couponType);
  this.couponMinPrice = is.readInt32(10, false, this.couponMinPrice);
  this.couponFavour = is.readInt32(11, false, this.couponFavour);
  this.winTime = is.readInt64(12, false, this.winTime);
  this.startTime = is.readInt64(13, false, this.startTime);
  this.endTime = is.readInt64(14, false, this.endTime);
  this.effectiveStartTime = is.readInt64(15, false, this.effectiveStartTime);
  this.effectiveEndTime = is.readInt64(16, false, this.effectiveEndTime);
  this.useStatus = is.readInt32(17, false, this.useStatus);
  this.ifCanUse = is.readInt32(18, false, this.ifCanUse);
  this.location = is.readString(19, false, this.location);
  this.totalCount = is.readInt32(20, false, this.totalCount);
  this.leavingCount = is.readInt32(21, false, this.leavingCount);
  this.useLifespane = is.readInt32(22, false, this.useLifespane);
  this.gameName = is.readString(23, false, this.gameName);
  this.canotUseReason = is.readString(24, false, this.canotUseReason);
  this.couponUsePreConditionDesc = is.readString(
    25,
    false,
    this.couponUsePreConditionDesc
  );
};

GameRelease.GameCoupon.prototype.writeTo = function (os) {
  os.writeInt64(0, this.couponId);
  os.writeInt64(1, this.recordId);
  os.writeInt32(2, this.gameId);
  os.writeString(3, this.couponName);
  os.writeString(4, this.couponDesc);
  os.writeString(5, this.couponUsePreCondition);
  os.writeString(6, this.couponUuid);
  os.writeString(7, this.couponCode);
  os.writeString(8, this.serial);
  os.writeInt32(9, this.couponType);
  os.writeInt32(10, this.couponMinPrice);
  os.writeInt32(11, this.couponFavour);
  os.writeInt64(12, this.winTime);
  os.writeInt64(13, this.startTime);
  os.writeInt64(14, this.endTime);
  os.writeInt64(15, this.effectiveStartTime);
  os.writeInt64(16, this.effectiveEndTime);
  os.writeInt32(17, this.useStatus);
  os.writeInt32(18, this.ifCanUse);
  os.writeString(19, this.location);
  os.writeInt32(20, this.totalCount);
  os.writeInt32(21, this.leavingCount);
  os.writeInt32(22, this.useLifespane);
  os.writeString(23, this.gameName);
  os.writeString(24, this.canotUseReason);
  os.writeString(25, this.couponUsePreConditionDesc);
};

GameRelease.GameCoupon.prototype._clone = function () {
  return new GameRelease.GameCoupon();
};
GameRelease.GameCoupon.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GameCoupon.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GetGidLiveRoomReq = function () {
  this.tId = new HUYA.UserId();
  this.gid = 0;
  this.page = 0;
  this.size = 0;
};

GameRelease.GetGidLiveRoomReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.gid = is.readInt32(1, false, this.gid);
  this.page = is.readInt32(2, false, this.page);
  this.size = is.readInt32(3, false, this.size);
};

GameRelease.GetGidLiveRoomReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeInt32(1, this.gid);
  os.writeInt32(2, this.page);
  os.writeInt32(3, this.size);
};

GameRelease.GetGidLiveRoomReq.prototype._clone = function () {
  return new GameRelease.GetGidLiveRoomReq();
};
GameRelease.GetGidLiveRoomReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GetGidLiveRoomReq.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GetGidLiveRoomRsp = function () {
  this.response = new GameRelease.GameCeterResponse();
  this.liveRoomList = new Taf.Vector(new GameRelease.LiveRoomInfo());
  this.liveRoomCount = 0;
};

GameRelease.GetGidLiveRoomRsp.prototype.readFrom = function (is) {
  this.response = is.readStruct(0, false, this.response);
  this.liveRoomList = is.readVector(1, false, this.liveRoomList);
  this.liveRoomCount = is.readInt32(2, false, this.liveRoomCount);
};

GameRelease.GetGidLiveRoomRsp.prototype.writeTo = function (os) {
  os.writeStruct(0, this.response);
  os.writeVector(1, this.liveRoomList);
  os.writeInt32(2, this.liveRoomCount);
};

GameRelease.GetGidLiveRoomRsp.prototype._clone = function () {
  return new GameRelease.GetGidLiveRoomRsp();
};
GameRelease.GetGidLiveRoomRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GetGidLiveRoomRsp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.LiveRoomInfo = function () {
  this.anchorUid = 0;
  this.nick = "";
  this.avatar = "";
  this.popularityValue = 0;
  this.cover = "";
  this.liveJumpUrl = "";
  this.liveRoomDesc = "";
  this.anchorTag = new Taf.Vector(new Taf.STRING());
  this.gid = 0;
};

GameRelease.LiveRoomInfo.prototype.readFrom = function (is) {
  this.anchorUid = is.readInt64(0, false, this.anchorUid);
  this.nick = is.readString(1, false, this.nick);
  this.avatar = is.readString(2, false, this.avatar);
  this.popularityValue = is.readInt32(3, false, this.popularityValue);
  this.cover = is.readString(4, false, this.cover);
  this.liveJumpUrl = is.readString(5, false, this.liveJumpUrl);
  this.liveRoomDesc = is.readString(6, false, this.liveRoomDesc);
  this.anchorTag = is.readVector(7, false, this.anchorTag);
  this.gid = is.readInt32(8, false, this.gid);
};

GameRelease.LiveRoomInfo.prototype.writeTo = function (os) {
  os.writeInt64(0, this.anchorUid);
  os.writeString(1, this.nick);
  os.writeString(2, this.avatar);
  os.writeInt32(3, this.popularityValue);
  os.writeString(4, this.cover);
  os.writeString(5, this.liveJumpUrl);
  os.writeString(6, this.liveRoomDesc);
  os.writeVector(7, this.anchorTag);
  os.writeInt32(8, this.gid);
};

GameRelease.LiveRoomInfo.prototype._clone = function () {
  return new GameRelease.LiveRoomInfo();
};
GameRelease.LiveRoomInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.LiveRoomInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GameDetailReq = function () {
  this.tId = new HUYA.UserId();
  this.gameId = 0;
  this.chId = 0;
  this.all = 0;
  this.hide = 0;
  this.anchorId = 0;
  this.traceId = "";
  this.channelNumber = "";
};

GameRelease.GameDetailReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.gameId = is.readInt32(1, false, this.gameId);
  this.chId = is.readInt32(2, false, this.chId);
  this.all = is.readInt32(3, false, this.all);
  this.hide = is.readInt32(4, false, this.hide);
  this.anchorId = is.readInt64(5, false, this.anchorId);
  this.traceId = is.readString(7, false, this.traceId);
  this.channelNumber = is.readString(8, false, this.channelNumber);
};

GameRelease.GameDetailReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeInt32(1, this.gameId);
  os.writeInt32(2, this.chId);
  os.writeInt32(3, this.all);
  os.writeInt32(4, this.hide);
  os.writeInt64(5, this.anchorId);
  os.writeString(7, this.traceId);
  os.writeString(8, this.channelNumber);
};

GameRelease.GameDetailReq.prototype._clone = function () {
  return new GameRelease.GameDetailReq();
};
GameRelease.GameDetailReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GameDetailReq.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GameDetailResp = function () {
  this.response = new GameRelease.GameCeterResponse();
  this.gameDetail = new GameRelease.GameDetail();
  this.traceId = "";
};

GameRelease.GameDetailResp.prototype.readFrom = function (is) {
  this.response = is.readStruct(0, false, this.response);
  this.gameDetail = is.readStruct(1, false, this.gameDetail);
  this.traceId = is.readString(3, false, this.traceId);
};

GameRelease.GameDetailResp.prototype.writeTo = function (os) {
  os.writeStruct(0, this.response);
  os.writeStruct(1, this.gameDetail);
  os.writeString(3, this.traceId);
};

GameRelease.GameDetailResp.prototype._clone = function () {
  return new GameRelease.GameDetailResp();
};
GameRelease.GameDetailResp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GameDetailResp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GameDetail = function () {
  this.gameBaseInfo = new GameRelease.GameBaseInfo();
  this.gameResourceInfo = new GameRelease.GameResourceInfo();
  this.gameWelfareInfoList = new Taf.Vector(new GameRelease.GameWelfareInfo());
  this.showOrder = new Taf.Vector(new Taf.INT32());
  this.categoryId = 0;
  this.configText = "";
  this.sourceId = 0;
  this.circleId = 0;
  this.circleTabId = 0;
  this.innerWelfares = new Taf.Vector(new GameRelease.GameInnerWelfare());
  this.canReceivedCouponCnt = 0;
  this.trendInfo = new GameRelease.GameTrendInfo();
  this.topicInfo = new HUYA.VideoTopic();
  this.adInfo = new GameRelease.GameAdInfo();
  this.hideBtn = 0;
  this.gameExtraInfo = new GameRelease.GameExtraInfoShow();
};

GameRelease.GameDetail.prototype.readFrom = function (is) {
  this.gameBaseInfo = is.readStruct(0, false, this.gameBaseInfo);
  this.gameResourceInfo = is.readStruct(1, false, this.gameResourceInfo);
  this.gameWelfareInfoList = is.readVector(2, false, this.gameWelfareInfoList);
  this.showOrder = is.readVector(3, false, this.showOrder);
  this.categoryId = is.readInt32(4, false, this.categoryId);
  this.configText = is.readString(5, false, this.configText);
  this.sourceId = is.readInt32(6, false, this.sourceId);
  this.circleId = is.readInt32(7, false, this.circleId);
  this.circleTabId = is.readInt32(8, false, this.circleTabId);
  this.innerWelfares = is.readVector(9, false, this.innerWelfares);
  this.canReceivedCouponCnt = is.readInt32(
    10,
    false,
    this.canReceivedCouponCnt
  );
  this.trendInfo = is.readStruct(11, false, this.trendInfo);
  this.topicInfo = is.readStruct(12, false, this.topicInfo);
  this.adInfo = is.readStruct(13, false, this.adInfo);
  this.hideBtn = is.readInt32(14, false, this.hideBtn);
  this.gameExtraInfo = is.readStruct(15, false, this.gameExtraInfo);
};

GameRelease.GameDetail.prototype.writeTo = function (os) {
  os.writeStruct(0, this.gameBaseInfo);
  os.writeStruct(1, this.gameResourceInfo);
  os.writeVector(2, this.gameWelfareInfoList);
  os.writeVector(3, this.showOrder);
  os.writeInt32(4, this.categoryId);
  os.writeString(5, this.configText);
  os.writeInt32(6, this.sourceId);
  os.writeInt32(7, this.circleId);
  os.writeInt32(8, this.circleTabId);
  os.writeVector(9, this.innerWelfares);
  os.writeInt32(10, this.canReceivedCouponCnt);
  os.writeStruct(11, this.trendInfo);
  os.writeStruct(12, this.topicInfo);
  os.writeStruct(13, this.adInfo);
  os.writeInt32(14, this.hideBtn);
  os.writeStruct(15, this.gameExtraInfo);
};

GameRelease.GameDetail.prototype._clone = function () {
  return new GameRelease.GameDetail();
};
GameRelease.GameDetail.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GameDetail.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GameBaseInfo = function () {
  this.gameId = 0;
  this.gameName = "";
  this.gameIcon = "";
  this.gameScore = "";
  this.gameTags = new Taf.Vector(new GameRelease.GameTag());
  this.isIos = 0;
  this.isAndroid = 0;
  this.gameDownloadCount = 0;
  this.gamePublisher = "";
  this.gameDeveloper = "";
  this.gameBrief = "";
  this.gameIntro = "";
  this.gameLatestReleases = "";
  this.gameLanguages = "";
  this.gameEnvironments = "";
  this.gameScreenshots = "";
  this.gameVideos = "";
  this.vid = "";
  this.commentId = "";
  this.isHorizontalScreen = 0;
  this.gameVideoScreenshot = "";
  this.gameVideoDuration = "";
  this.postStatus = 0;
  this.reserveNum = 0;
  this.isReserve = 0;
  this.reserveInfo = "";
  this.reserveDetails = new Taf.Vector(new GameRelease.ReserveDetail());
  this.noticeText = "";
  this.noticeUrl = "";
  this.mediaInfo = new GameRelease.GameMediaInfo();
  this.dynamicInfo = new GameRelease.GameDynamicInfo();
  this.noticeInfo = new Taf.Vector(new GameRelease.GameNoticeInfo());
  this.tip = "";
  this.developerWords = "";
  this.recGame = 0;
  this.publishTime = 0;
  this.tGuideReserve = new GameRelease.GameGuideReserve();
  this.joint = 0;
  this.guideBtnJumpUrl = "";
  this.guideBtnText = "";
  this.isReserveWifi = 0;
  this.status = 0;
  this.appId = 0;
  this.baseGameId = 0;
  this.cloudSwitch = 0;
  this.cloudType = new Taf.Vector(new Taf.INT32());
  this.yybGid = 0;
  this.gameType = 0;
  this.isCloudGameWhite = 0;
  this.cloudGamePCLink = "";
  this.isSimulator = 0;
  this.isShowPcGameCenter = 0;
  this.isOnlinePcYyb = 0;
  this.dayScheduleInfo = new GameRelease.GameDayScheduleInfo();
};

GameRelease.GameBaseInfo.prototype.readFrom = function (is) {
  this.gameId = is.readInt32(0, false, this.gameId);
  this.gameName = is.readString(1, false, this.gameName);
  this.gameIcon = is.readString(2, false, this.gameIcon);
  this.gameScore = is.readString(3, false, this.gameScore);
  this.gameTags = is.readVector(4, false, this.gameTags);
  this.isIos = is.readInt32(5, false, this.isIos);
  this.isAndroid = is.readInt32(6, false, this.isAndroid);
  this.gameDownloadCount = is.readInt32(7, false, this.gameDownloadCount);
  this.gamePublisher = is.readString(8, false, this.gamePublisher);
  this.gameDeveloper = is.readString(9, false, this.gameDeveloper);
  this.gameBrief = is.readString(10, false, this.gameBrief);
  this.gameIntro = is.readString(11, false, this.gameIntro);
  this.gameLatestReleases = is.readString(12, false, this.gameLatestReleases);
  this.gameLanguages = is.readString(13, false, this.gameLanguages);
  this.gameEnvironments = is.readString(14, false, this.gameEnvironments);
  this.gameScreenshots = is.readString(15, false, this.gameScreenshots);
  this.gameVideos = is.readString(16, false, this.gameVideos);
  this.vid = is.readString(17, false, this.vid);
  this.commentId = is.readString(18, false, this.commentId);
  this.isHorizontalScreen = is.readInt32(19, false, this.isHorizontalScreen);
  this.gameVideoScreenshot = is.readString(20, false, this.gameVideoScreenshot);
  this.gameVideoDuration = is.readString(21, false, this.gameVideoDuration);
  this.postStatus = is.readInt32(22, false, this.postStatus);
  this.reserveNum = is.readInt32(23, false, this.reserveNum);
  this.isReserve = is.readInt32(24, false, this.isReserve);
  this.reserveInfo = is.readString(25, false, this.reserveInfo);
  this.reserveDetails = is.readVector(26, false, this.reserveDetails);
  this.noticeText = is.readString(27, false, this.noticeText);
  this.noticeUrl = is.readString(28, false, this.noticeUrl);
  this.mediaInfo = is.readStruct(29, false, this.mediaInfo);
  this.dynamicInfo = is.readStruct(30, false, this.dynamicInfo);
  this.noticeInfo = is.readVector(31, false, this.noticeInfo);
  this.tip = is.readString(32, false, this.tip);
  this.developerWords = is.readString(33, false, this.developerWords);
  this.recGame = is.readInt32(34, false, this.recGame);
  this.publishTime = is.readInt32(35, false, this.publishTime);
  this.tGuideReserve = is.readStruct(36, false, this.tGuideReserve);
  this.joint = is.readInt32(37, false, this.joint);
  this.guideBtnJumpUrl = is.readString(38, false, this.guideBtnJumpUrl);
  this.guideBtnText = is.readString(39, false, this.guideBtnText);
  this.isReserveWifi = is.readInt32(40, false, this.isReserveWifi);
  this.status = is.readInt32(41, false, this.status);
  this.appId = is.readInt32(42, false, this.appId);
  this.baseGameId = is.readInt64(43, false, this.baseGameId);
  this.cloudSwitch = is.readInt32(44, false, this.cloudSwitch);
  this.cloudType = is.readVector(46, false, this.cloudType);
  this.yybGid = is.readInt64(47, false, this.yybGid);
  this.gameType = is.readInt32(48, false, this.gameType);
  this.isCloudGameWhite = is.readInt32(49, false, this.isCloudGameWhite);
  this.cloudGamePCLink = is.readString(50, false, this.cloudGamePCLink);
  this.isSimulator = is.readInt32(51, false, this.isSimulator);
  this.isShowPcGameCenter = is.readInt32(52, false, this.isShowPcGameCenter);
  this.isOnlinePcYyb = is.readInt32(53, false, this.isOnlinePcYyb);
  this.dayScheduleInfo = is.readStruct(56, false, this.dayScheduleInfo);
};

GameRelease.GameBaseInfo.prototype.writeTo = function (os) {
  os.writeInt32(0, this.gameId);
  os.writeString(1, this.gameName);
  os.writeString(2, this.gameIcon);
  os.writeString(3, this.gameScore);
  os.writeVector(4, this.gameTags);
  os.writeInt32(5, this.isIos);
  os.writeInt32(6, this.isAndroid);
  os.writeInt32(7, this.gameDownloadCount);
  os.writeString(8, this.gamePublisher);
  os.writeString(9, this.gameDeveloper);
  os.writeString(10, this.gameBrief);
  os.writeString(11, this.gameIntro);
  os.writeString(12, this.gameLatestReleases);
  os.writeString(13, this.gameLanguages);
  os.writeString(14, this.gameEnvironments);
  os.writeString(15, this.gameScreenshots);
  os.writeString(16, this.gameVideos);
  os.writeString(17, this.vid);
  os.writeString(18, this.commentId);
  os.writeInt32(19, this.isHorizontalScreen);
  os.writeString(20, this.gameVideoScreenshot);
  os.writeString(21, this.gameVideoDuration);
  os.writeInt32(22, this.postStatus);
  os.writeInt32(23, this.reserveNum);
  os.writeInt32(24, this.isReserve);
  os.writeString(25, this.reserveInfo);
  os.writeVector(26, this.reserveDetails);
  os.writeString(27, this.noticeText);
  os.writeString(28, this.noticeUrl);
  os.writeStruct(29, this.mediaInfo);
  os.writeStruct(30, this.dynamicInfo);
  os.writeVector(31, this.noticeInfo);
  os.writeString(32, this.tip);
  os.writeString(33, this.developerWords);
  os.writeInt32(34, this.recGame);
  os.writeInt32(35, this.publishTime);
  os.writeStruct(36, this.tGuideReserve);
  os.writeInt32(37, this.joint);
  os.writeString(38, this.guideBtnJumpUrl);
  os.writeString(39, this.guideBtnText);
  os.writeInt32(40, this.isReserveWifi);
  os.writeInt32(41, this.status);
  os.writeInt32(42, this.appId);
  os.writeInt64(43, this.baseGameId);
  os.writeInt32(44, this.cloudSwitch);
  os.writeVector(46, this.cloudType);
  os.writeInt64(47, this.yybGid);
  os.writeInt32(48, this.gameType);
  os.writeInt32(49, this.isCloudGameWhite);
  os.writeString(50, this.cloudGamePCLink);
  os.writeInt32(51, this.isSimulator);
  os.writeInt32(52, this.isShowPcGameCenter);
  os.writeInt32(53, this.isOnlinePcYyb);
  os.writeStruct(56, this.dayScheduleInfo);
};

GameRelease.GameBaseInfo.prototype._clone = function () {
  return new GameRelease.GameBaseInfo();
};
GameRelease.GameBaseInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GameBaseInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GameTag = function () {
  this.tagId = 0;
  this.tagName = "";
  this.isCategory = 0;
};

GameRelease.GameTag.prototype.readFrom = function (is) {
  this.tagId = is.readInt32(0, false, this.tagId);
  this.tagName = is.readString(1, false, this.tagName);
  this.isCategory = is.readInt32(2, false, this.isCategory);
};

GameRelease.GameTag.prototype.writeTo = function (os) {
  os.writeInt32(0, this.tagId);
  os.writeString(1, this.tagName);
  os.writeInt32(2, this.isCategory);
};

GameRelease.GameTag.prototype._clone = function () {
  return new GameRelease.GameTag();
};
GameRelease.GameTag.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GameTag.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.ReserveDetail = function () {
  this.id = 0;
  this.tip = "";
  this.field = "";
  this.isRequired = 0;
};

GameRelease.ReserveDetail.prototype.readFrom = function (is) {
  this.id = is.readInt32(0, false, this.id);
  this.tip = is.readString(1, false, this.tip);
  this.field = is.readString(2, false, this.field);
  this.isRequired = is.readInt32(3, false, this.isRequired);
};

GameRelease.ReserveDetail.prototype.writeTo = function (os) {
  os.writeInt32(0, this.id);
  os.writeString(1, this.tip);
  os.writeString(2, this.field);
  os.writeInt32(3, this.isRequired);
};

GameRelease.ReserveDetail.prototype._clone = function () {
  return new GameRelease.ReserveDetail();
};
GameRelease.ReserveDetail.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.ReserveDetail.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GameMediaInfo = function () {
  this.liveIds = new Taf.Vector(new Taf.INT64());
  this.uids = new Taf.Vector(new Taf.INT64());
  this.videoUrl = "";
  this.items = new Taf.Vector(new GameRelease.GameMediaInfoItem());
};

GameRelease.GameMediaInfo.prototype.readFrom = function (is) {
  this.liveIds = is.readVector(0, false, this.liveIds);
  this.uids = is.readVector(1, false, this.uids);
  this.videoUrl = is.readString(2, false, this.videoUrl);
  this.items = is.readVector(3, false, this.items);
};

GameRelease.GameMediaInfo.prototype.writeTo = function (os) {
  os.writeVector(0, this.liveIds);
  os.writeVector(1, this.uids);
  os.writeString(2, this.videoUrl);
  os.writeVector(3, this.items);
};

GameRelease.GameMediaInfo.prototype._clone = function () {
  return new GameRelease.GameMediaInfo();
};
GameRelease.GameMediaInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GameMediaInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GameMediaInfoItem = function () {
  this.type = 0;
  this.key1 = "";
  this.value = "";
  this.startTime = 0;
  this.endTime = 0;
  this.img = "";
};

GameRelease.GameMediaInfoItem.prototype.readFrom = function (is) {
  this.type = is.readInt32(0, false, this.type);
  this.key1 = is.readString(1, false, this.key1);
  this.value = is.readString(2, false, this.value);
  this.startTime = is.readInt64(3, false, this.startTime);
  this.endTime = is.readInt64(4, false, this.endTime);
  this.img = is.readString(5, false, this.img);
};

GameRelease.GameMediaInfoItem.prototype.writeTo = function (os) {
  os.writeInt32(0, this.type);
  os.writeString(1, this.key1);
  os.writeString(2, this.value);
  os.writeInt64(3, this.startTime);
  os.writeInt64(4, this.endTime);
  os.writeString(5, this.img);
};

GameRelease.GameMediaInfoItem.prototype._clone = function () {
  return new GameRelease.GameMediaInfoItem();
};
GameRelease.GameMediaInfoItem.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GameMediaInfoItem.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GameDynamicInfo = function () {
  this.ms = 0;
  this.text = "";
  this.dlWndContent = "";
};

GameRelease.GameDynamicInfo.prototype.readFrom = function (is) {
  this.ms = is.readInt64(0, false, this.ms);
  this.text = is.readString(1, false, this.text);
  this.dlWndContent = is.readString(2, false, this.dlWndContent);
};

GameRelease.GameDynamicInfo.prototype.writeTo = function (os) {
  os.writeInt64(0, this.ms);
  os.writeString(1, this.text);
  os.writeString(2, this.dlWndContent);
};

GameRelease.GameDynamicInfo.prototype._clone = function () {
  return new GameRelease.GameDynamicInfo();
};
GameRelease.GameDynamicInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GameDynamicInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GameNoticeInfo = function () {
  this.tag = "";
  this.text = "";
  this.url = "";
  this.isDownloadPage = 0;
};

GameRelease.GameNoticeInfo.prototype.readFrom = function (is) {
  this.tag = is.readString(0, false, this.tag);
  this.text = is.readString(1, false, this.text);
  this.url = is.readString(2, false, this.url);
  this.isDownloadPage = is.readInt32(3, false, this.isDownloadPage);
};

GameRelease.GameNoticeInfo.prototype.writeTo = function (os) {
  os.writeString(0, this.tag);
  os.writeString(1, this.text);
  os.writeString(2, this.url);
  os.writeInt32(3, this.isDownloadPage);
};

GameRelease.GameNoticeInfo.prototype._clone = function () {
  return new GameRelease.GameNoticeInfo();
};
GameRelease.GameNoticeInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GameNoticeInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GameGuideReserve = function () {
  this.iRelatedGameId = 0;
  this.iGuidReserve = 0;
  this.sGuidReserveText = "";
  this.sBtnLongText = "";
  this.sBtnShortText = "";
  this.sRelatedBtnLongText = "";
  this.sRelatedBtnShortText = "";
  this.iRelatedPostStatus = 0;
  this.iRelatedIsReverse = 0;
  this.sRelatedGameIcon = "";
  this.sRelatedGameName = "";
};

GameRelease.GameGuideReserve.prototype.readFrom = function (is) {
  this.iRelatedGameId = is.readInt32(0, false, this.iRelatedGameId);
  this.iGuidReserve = is.readInt32(1, false, this.iGuidReserve);
  this.sGuidReserveText = is.readString(2, false, this.sGuidReserveText);
  this.sBtnLongText = is.readString(3, false, this.sBtnLongText);
  this.sBtnShortText = is.readString(4, false, this.sBtnShortText);
  this.sRelatedBtnLongText = is.readString(5, false, this.sRelatedBtnLongText);
  this.sRelatedBtnShortText = is.readString(
    6,
    false,
    this.sRelatedBtnShortText
  );
  this.iRelatedPostStatus = is.readInt32(7, false, this.iRelatedPostStatus);
  this.iRelatedIsReverse = is.readInt32(8, false, this.iRelatedIsReverse);
  this.sRelatedGameIcon = is.readString(9, false, this.sRelatedGameIcon);
  this.sRelatedGameName = is.readString(10, false, this.sRelatedGameName);
};

GameRelease.GameGuideReserve.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iRelatedGameId);
  os.writeInt32(1, this.iGuidReserve);
  os.writeString(2, this.sGuidReserveText);
  os.writeString(3, this.sBtnLongText);
  os.writeString(4, this.sBtnShortText);
  os.writeString(5, this.sRelatedBtnLongText);
  os.writeString(6, this.sRelatedBtnShortText);
  os.writeInt32(7, this.iRelatedPostStatus);
  os.writeInt32(8, this.iRelatedIsReverse);
  os.writeString(9, this.sRelatedGameIcon);
  os.writeString(10, this.sRelatedGameName);
};

GameRelease.GameGuideReserve.prototype._clone = function () {
  return new GameRelease.GameGuideReserve();
};
GameRelease.GameGuideReserve.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GameGuideReserve.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GameDayScheduleInfo = function () {
  this.ms = 0;
  this.title = "";
  this.content = "";
  this.jumpUrl = "";
};

GameRelease.GameDayScheduleInfo.prototype.readFrom = function (is) {
  this.ms = is.readInt64(0, false, this.ms);
  this.title = is.readString(1, false, this.title);
  this.content = is.readString(2, false, this.content);
  this.jumpUrl = is.readString(3, false, this.jumpUrl);
};

GameRelease.GameDayScheduleInfo.prototype.writeTo = function (os) {
  os.writeInt64(0, this.ms);
  os.writeString(1, this.title);
  os.writeString(2, this.content);
  os.writeString(3, this.jumpUrl);
};

GameRelease.GameDayScheduleInfo.prototype._clone = function () {
  return new GameRelease.GameDayScheduleInfo();
};
GameRelease.GameDayScheduleInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GameDayScheduleInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GameResourceInfo = function () {
  this.gameId = 0;
  this.iosAppStoreId = "";
  this.iosDownloadUrl = "";
  this.iosVersion = "";
  this.adrPackageName = "";
  this.adrDownloadUrl = "";
  this.adrVersion = "";
  this.iosFileSize = "";
  this.adrFileSize = "";
  this.apkPermission = "";
  this.privacyPolicy = "";
  this.adrVersionCode = 0;
  this.adrFileMd5 = "";
  this.adrPreVersionCode = 0;
  this.adrPreDownloadUrl = "";
  this.adrPreFileMd5 = "";
  this.adrPreBundleId = "";
  this.iosIeg = 0;
  this.yybGid = 0;
  this.linkUrl = "";
  this.channelId = 0;
  this.apkType = 0;
  this.iosSchema = "";
  this.isIos = 0;
  this.isAndroid = 0;
  this.isPc = 0;
  this.channelNumber = "";
  this.iosAscribeInfo = "";
  this.adrSystemMinVersionCode = 0;
};

GameRelease.GameResourceInfo.prototype.readFrom = function (is) {
  this.gameId = is.readInt32(0, false, this.gameId);
  this.iosAppStoreId = is.readString(1, false, this.iosAppStoreId);
  this.iosDownloadUrl = is.readString(2, false, this.iosDownloadUrl);
  this.iosVersion = is.readString(3, false, this.iosVersion);
  this.adrPackageName = is.readString(4, false, this.adrPackageName);
  this.adrDownloadUrl = is.readString(5, false, this.adrDownloadUrl);
  this.adrVersion = is.readString(6, false, this.adrVersion);
  this.iosFileSize = is.readString(7, false, this.iosFileSize);
  this.adrFileSize = is.readString(8, false, this.adrFileSize);
  this.apkPermission = is.readString(9, false, this.apkPermission);
  this.privacyPolicy = is.readString(10, false, this.privacyPolicy);
  this.adrVersionCode = is.readInt64(12, false, this.adrVersionCode);
  this.adrFileMd5 = is.readString(13, false, this.adrFileMd5);
  this.adrPreVersionCode = is.readInt64(14, false, this.adrPreVersionCode);
  this.adrPreDownloadUrl = is.readString(15, false, this.adrPreDownloadUrl);
  this.adrPreFileMd5 = is.readString(16, false, this.adrPreFileMd5);
  this.adrPreBundleId = is.readString(17, false, this.adrPreBundleId);
  this.iosIeg = is.readInt32(18, false, this.iosIeg);
  this.yybGid = is.readInt64(19, false, this.yybGid);
  this.linkUrl = is.readString(20, false, this.linkUrl);
  this.channelId = is.readInt64(21, false, this.channelId);
  this.apkType = is.readInt32(22, false, this.apkType);
  this.iosSchema = is.readString(23, false, this.iosSchema);
  this.isIos = is.readInt32(24, false, this.isIos);
  this.isAndroid = is.readInt32(25, false, this.isAndroid);
  this.isPc = is.readInt32(26, false, this.isPc);
  this.channelNumber = is.readString(27, false, this.channelNumber);
  this.iosAscribeInfo = is.readString(28, false, this.iosAscribeInfo);
  this.adrSystemMinVersionCode = is.readInt32(
    29,
    false,
    this.adrSystemMinVersionCode
  );
};

GameRelease.GameResourceInfo.prototype.writeTo = function (os) {
  os.writeInt32(0, this.gameId);
  os.writeString(1, this.iosAppStoreId);
  os.writeString(2, this.iosDownloadUrl);
  os.writeString(3, this.iosVersion);
  os.writeString(4, this.adrPackageName);
  os.writeString(5, this.adrDownloadUrl);
  os.writeString(6, this.adrVersion);
  os.writeString(7, this.iosFileSize);
  os.writeString(8, this.adrFileSize);
  os.writeString(9, this.apkPermission);
  os.writeString(10, this.privacyPolicy);
  os.writeInt64(12, this.adrVersionCode);
  os.writeString(13, this.adrFileMd5);
  os.writeInt64(14, this.adrPreVersionCode);
  os.writeString(15, this.adrPreDownloadUrl);
  os.writeString(16, this.adrPreFileMd5);
  os.writeString(17, this.adrPreBundleId);
  os.writeInt32(18, this.iosIeg);
  os.writeInt64(19, this.yybGid);
  os.writeString(20, this.linkUrl);
  os.writeInt64(21, this.channelId);
  os.writeInt32(22, this.apkType);
  os.writeString(23, this.iosSchema);
  os.writeInt32(24, this.isIos);
  os.writeInt32(25, this.isAndroid);
  os.writeInt32(26, this.isPc);
  os.writeString(27, this.channelNumber);
  os.writeString(28, this.iosAscribeInfo);
  os.writeInt32(29, this.adrSystemMinVersionCode);
};

GameRelease.GameResourceInfo.prototype._clone = function () {
  return new GameRelease.GameResourceInfo();
};
GameRelease.GameResourceInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GameResourceInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GameWelfareInfo = function () {
  this.gameId = 0;
  this.welfareId = 0;
  this.welfareName = "";
  this.welfareType = 0;
  this.welfareUsage = "";
  this.welfareIntro = "";
  this.welfareCount = 0;
  this.welfareUsedCount = 0;
  this.startTime = 0;
  this.endTime = 0;
  this.status = 0;
  this.packParam = new Taf.Map(new Taf.STRING(), new Taf.STRING());
  this.currentTime = 0;
  this.duration = 0;
  this.contents = new Taf.Vector(new GameRelease.GameWelfareInfoContent());
  this.isReceive = 0;
  this.effectiveStartTime = 0;
  this.effectiveEndTime = 0;
  this.receiveStatus = 0;
  this.activationCode = new GameRelease.WelfareActivationCode();
  this.userIfCanPick = 0;
  this.pickCountRecent = 0;
  this.onlineCount = 0;
  this.weight = 0;
  this.platform = "";
  this.prizeType = 0;
  this.isGameAccount = 0;
  this.categoryId = 0;
  this.prizeParam = new Taf.Map(new Taf.STRING(), new Taf.STRING());
};

GameRelease.GameWelfareInfo.prototype.readFrom = function (is) {
  this.gameId = is.readInt32(0, false, this.gameId);
  this.welfareId = is.readInt32(1, false, this.welfareId);
  this.welfareName = is.readString(2, false, this.welfareName);
  this.welfareType = is.readInt32(3, false, this.welfareType);
  this.welfareUsage = is.readString(4, false, this.welfareUsage);
  this.welfareIntro = is.readString(5, false, this.welfareIntro);
  this.welfareCount = is.readInt32(6, false, this.welfareCount);
  this.welfareUsedCount = is.readInt32(7, false, this.welfareUsedCount);
  this.startTime = is.readInt32(8, false, this.startTime);
  this.endTime = is.readInt32(9, false, this.endTime);
  this.status = is.readInt32(10, false, this.status);
  this.packParam = is.readMap(11, false, this.packParam);
  this.currentTime = is.readInt32(12, false, this.currentTime);
  this.duration = is.readInt32(13, false, this.duration);
  this.contents = is.readVector(14, false, this.contents);
  this.isReceive = is.readInt32(15, false, this.isReceive);
  this.effectiveStartTime = is.readInt32(16, false, this.effectiveStartTime);
  this.effectiveEndTime = is.readInt32(17, false, this.effectiveEndTime);
  this.receiveStatus = is.readInt32(18, false, this.receiveStatus);
  this.activationCode = is.readStruct(19, false, this.activationCode);
  this.userIfCanPick = is.readInt32(20, false, this.userIfCanPick);
  this.pickCountRecent = is.readInt32(21, false, this.pickCountRecent);
  this.onlineCount = is.readInt32(22, false, this.onlineCount);
  this.weight = is.readInt32(23, false, this.weight);
  this.platform = is.readString(24, false, this.platform);
  this.prizeType = is.readInt32(29, false, this.prizeType);
  this.isGameAccount = is.readInt32(30, false, this.isGameAccount);
  this.categoryId = is.readInt32(31, false, this.categoryId);
  this.prizeParam = is.readMap(32, false, this.prizeParam);
};

GameRelease.GameWelfareInfo.prototype.writeTo = function (os) {
  os.writeInt32(0, this.gameId);
  os.writeInt32(1, this.welfareId);
  os.writeString(2, this.welfareName);
  os.writeInt32(3, this.welfareType);
  os.writeString(4, this.welfareUsage);
  os.writeString(5, this.welfareIntro);
  os.writeInt32(6, this.welfareCount);
  os.writeInt32(7, this.welfareUsedCount);
  os.writeInt32(8, this.startTime);
  os.writeInt32(9, this.endTime);
  os.writeInt32(10, this.status);
  os.writeMap(11, this.packParam);
  os.writeInt32(12, this.currentTime);
  os.writeInt32(13, this.duration);
  os.writeVector(14, this.contents);
  os.writeInt32(15, this.isReceive);
  os.writeInt32(16, this.effectiveStartTime);
  os.writeInt32(17, this.effectiveEndTime);
  os.writeInt32(18, this.receiveStatus);
  os.writeStruct(19, this.activationCode);
  os.writeInt32(20, this.userIfCanPick);
  os.writeInt32(21, this.pickCountRecent);
  os.writeInt32(22, this.onlineCount);
  os.writeInt32(23, this.weight);
  os.writeString(24, this.platform);
  os.writeInt32(29, this.prizeType);
  os.writeInt32(30, this.isGameAccount);
  os.writeInt32(31, this.categoryId);
  os.writeMap(32, this.prizeParam);
};

GameRelease.GameWelfareInfo.prototype._clone = function () {
  return new GameRelease.GameWelfareInfo();
};
GameRelease.GameWelfareInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GameWelfareInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GameWelfareInfoContent = function () {
  this.contentName = "";
  this.contentImg = "";
};

GameRelease.GameWelfareInfoContent.prototype.readFrom = function (is) {
  this.contentName = is.readString(0, false, this.contentName);
  this.contentImg = is.readString(1, false, this.contentImg);
};

GameRelease.GameWelfareInfoContent.prototype.writeTo = function (os) {
  os.writeString(0, this.contentName);
  os.writeString(1, this.contentImg);
};

GameRelease.GameWelfareInfoContent.prototype._clone = function () {
  return new GameRelease.GameWelfareInfoContent();
};
GameRelease.GameWelfareInfoContent.prototype._write = function (
  os,
  tag,
  value
) {
  os.writeStruct(tag, value);
};
GameRelease.GameWelfareInfoContent.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.WelfareActivationCode = function () {
  this.welfareCode = "";
  this.welfarePwd = "";
};

GameRelease.WelfareActivationCode.prototype.readFrom = function (is) {
  this.welfareCode = is.readString(0, false, this.welfareCode);
  this.welfarePwd = is.readString(1, false, this.welfarePwd);
};

GameRelease.WelfareActivationCode.prototype.writeTo = function (os) {
  os.writeString(0, this.welfareCode);
  os.writeString(1, this.welfarePwd);
};

GameRelease.WelfareActivationCode.prototype._clone = function () {
  return new GameRelease.WelfareActivationCode();
};
GameRelease.WelfareActivationCode.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.WelfareActivationCode.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GameInnerWelfare = function () {
  this.id = 0;
  this.gameId = 0;
  this.type = 0;
  this.welfareName = "";
  this.startTime = 0;
  this.endTime = 0;
  this.giftPic = 0;
  this.items = new Taf.Vector(new GameRelease.GameInnerWelfareItem());
};

GameRelease.GameInnerWelfare.prototype.readFrom = function (is) {
  this.id = is.readInt64(0, false, this.id);
  this.gameId = is.readInt32(1, false, this.gameId);
  this.type = is.readInt32(2, false, this.type);
  this.welfareName = is.readString(3, false, this.welfareName);
  this.startTime = is.readInt32(4, false, this.startTime);
  this.endTime = is.readInt32(5, false, this.endTime);
  this.giftPic = is.readInt32(6, false, this.giftPic);
  this.items = is.readVector(7, false, this.items);
};

GameRelease.GameInnerWelfare.prototype.writeTo = function (os) {
  os.writeInt64(0, this.id);
  os.writeInt32(1, this.gameId);
  os.writeInt32(2, this.type);
  os.writeString(3, this.welfareName);
  os.writeInt32(4, this.startTime);
  os.writeInt32(5, this.endTime);
  os.writeInt32(6, this.giftPic);
  os.writeVector(7, this.items);
};

GameRelease.GameInnerWelfare.prototype._clone = function () {
  return new GameRelease.GameInnerWelfare();
};
GameRelease.GameInnerWelfare.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GameInnerWelfare.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GameInnerWelfareItem = function () {
  this.pic = "";
  this.desc = "";
  this.num = 0;
  this.index = 0;
};

GameRelease.GameInnerWelfareItem.prototype.readFrom = function (is) {
  this.pic = is.readString(0, false, this.pic);
  this.desc = is.readString(1, false, this.desc);
  this.num = is.readInt32(2, false, this.num);
  this.index = is.readInt32(3, false, this.index);
};

GameRelease.GameInnerWelfareItem.prototype.writeTo = function (os) {
  os.writeString(0, this.pic);
  os.writeString(1, this.desc);
  os.writeInt32(2, this.num);
  os.writeInt32(3, this.index);
};

GameRelease.GameInnerWelfareItem.prototype._clone = function () {
  return new GameRelease.GameInnerWelfareItem();
};
GameRelease.GameInnerWelfareItem.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GameInnerWelfareItem.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GameTrendInfo = function () {
  this.type = 0;
  this.content = "";
  this.jumpUrl = "";
  this.intValue = 0;
  this.strValue = "";
};

GameRelease.GameTrendInfo.prototype.readFrom = function (is) {
  this.type = is.readInt32(0, false, this.type);
  this.content = is.readString(1, false, this.content);
  this.jumpUrl = is.readString(2, false, this.jumpUrl);
  this.intValue = is.readInt32(3, false, this.intValue);
  this.strValue = is.readString(4, false, this.strValue);
};

GameRelease.GameTrendInfo.prototype.writeTo = function (os) {
  os.writeInt32(0, this.type);
  os.writeString(1, this.content);
  os.writeString(2, this.jumpUrl);
  os.writeInt32(3, this.intValue);
  os.writeString(4, this.strValue);
};

GameRelease.GameTrendInfo.prototype._clone = function () {
  return new GameRelease.GameTrendInfo();
};
GameRelease.GameTrendInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GameTrendInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.VideoTopic = function () {
  this.iTopicId = 0;
  this.sTopicTitle = "";
  this.iTopicVideoNum = 0;
  this.sTopicCover = "";
  this.sTopicVideoTitle = "";
  this.sTopicUrl = "";
  this.vVideoMoments = new Taf.Vector(new HUYA.MomentInfo());
  this.vRelatedPid = new Taf.Vector(new Taf.INT64());
  this.sTopicBrief = "";
  this.iTopicViews = 0;
  this.iTopicComments = 0;
  this.iWeight = 0;
  this.sShortTitle = "";
  this.iEnableHotSort = 0;
  this.sDetailUrl = "";
  this.vSort = new Taf.Vector(new Taf.INT32());
  this.iDefaultSort = 0;
  this.sCatagray = "";
  this.iRankType = 0;
  this.sTag = "";
  this.vTalker = new Taf.Vector(new HUYA.UserBase());
  this.iDisplayEnchance = 0;
  this.vRelatedKeyword = new Taf.Vector(new Taf.STRING());
  this.iTemplateType = 0;
  this.lPostTemplateId = 0;
  this.sTopicStatistics = "";
  this.lCreateTime = 0;
  this.lMainMomId = 0;
  this.lMainVId = 0;
  this.sHotSpotGrade = "";
};

HUYA.VideoTopic.prototype.readFrom = function (is) {
  this.iTopicId = is.readInt32(0, false, this.iTopicId);
  this.sTopicTitle = is.readString(1, false, this.sTopicTitle);
  this.iTopicVideoNum = is.readInt32(2, false, this.iTopicVideoNum);
  this.sTopicCover = is.readString(3, false, this.sTopicCover);
  this.sTopicVideoTitle = is.readString(4, false, this.sTopicVideoTitle);
  this.sTopicUrl = is.readString(5, false, this.sTopicUrl);
  this.vVideoMoments = is.readVector(6, false, this.vVideoMoments);
  this.vRelatedPid = is.readVector(7, false, this.vRelatedPid);
  this.sTopicBrief = is.readString(8, false, this.sTopicBrief);
  this.iTopicViews = is.readInt32(9, false, this.iTopicViews);
  this.iTopicComments = is.readInt32(10, false, this.iTopicComments);
  this.iWeight = is.readInt32(11, false, this.iWeight);
  this.sShortTitle = is.readString(12, false, this.sShortTitle);
  this.iEnableHotSort = is.readInt32(13, false, this.iEnableHotSort);
  this.sDetailUrl = is.readString(14, false, this.sDetailUrl);
  this.vSort = is.readVector(15, false, this.vSort);
  this.iDefaultSort = is.readInt32(16, false, this.iDefaultSort);
  this.sCatagray = is.readString(17, false, this.sCatagray);
  this.iRankType = is.readInt32(18, false, this.iRankType);
  this.sTag = is.readString(19, false, this.sTag);
  this.vTalker = is.readVector(20, false, this.vTalker);
  this.iDisplayEnchance = is.readInt32(21, false, this.iDisplayEnchance);
  this.vRelatedKeyword = is.readVector(22, false, this.vRelatedKeyword);
  this.iTemplateType = is.readInt32(23, false, this.iTemplateType);
  this.lPostTemplateId = is.readInt64(24, false, this.lPostTemplateId);
  this.sTopicStatistics = is.readString(25, false, this.sTopicStatistics);
  this.lCreateTime = is.readInt64(26, false, this.lCreateTime);
  this.lMainMomId = is.readInt64(27, false, this.lMainMomId);
  this.lMainVId = is.readInt64(28, false, this.lMainVId);
  this.sHotSpotGrade = is.readString(29, false, this.sHotSpotGrade);
};

HUYA.VideoTopic.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iTopicId);
  os.writeString(1, this.sTopicTitle);
  os.writeInt32(2, this.iTopicVideoNum);
  os.writeString(3, this.sTopicCover);
  os.writeString(4, this.sTopicVideoTitle);
  os.writeString(5, this.sTopicUrl);
  os.writeVector(6, this.vVideoMoments);
  os.writeVector(7, this.vRelatedPid);
  os.writeString(8, this.sTopicBrief);
  os.writeInt32(9, this.iTopicViews);
  os.writeInt32(10, this.iTopicComments);
  os.writeInt32(11, this.iWeight);
  os.writeString(12, this.sShortTitle);
  os.writeInt32(13, this.iEnableHotSort);
  os.writeString(14, this.sDetailUrl);
  os.writeVector(15, this.vSort);
  os.writeInt32(16, this.iDefaultSort);
  os.writeString(17, this.sCatagray);
  os.writeInt32(18, this.iRankType);
  os.writeString(19, this.sTag);
  os.writeVector(20, this.vTalker);
  os.writeInt32(21, this.iDisplayEnchance);
  os.writeVector(22, this.vRelatedKeyword);
  os.writeInt32(23, this.iTemplateType);
  os.writeInt64(24, this.lPostTemplateId);
  os.writeString(25, this.sTopicStatistics);
  os.writeInt64(26, this.lCreateTime);
  os.writeInt64(27, this.lMainMomId);
  os.writeInt64(28, this.lMainVId);
  os.writeString(29, this.sHotSpotGrade);
};

HUYA.VideoTopic.prototype._clone = function () {
  return new HUYA.VideoTopic();
};
HUYA.VideoTopic.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.VideoTopic.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentInfo = function () {
  this.lMomId = 0;
  this.iType = 0;
  this.lUid = 0;
  this.sNickName = "";
  this.sIconUrl = "";
  this.sTitle = "";
  this.sContent = "";
  this.iFavorCount = 0;
  this.iCommentCount = 0;
  this.iShareCount = 0;
  this.vComment = new Taf.Vector(new HUYA.CommentInfo());
  this.iCTime = 0;
  this.iStatus = 0;
  this.iOpt = 0;
  this.tVideoInfo = new HUYA.VideoInfo();
  this.vKeyWord = new Taf.Vector(new Taf.STRING());
  this.iHasDraw = 0;
  this.vCoverUrl = new Taf.Vector(new Taf.STRING());
  this.sHtmlDoc = "";
  this.vTags = new Taf.Vector(new Taf.STRING());
  this.vBelongPlate = new Taf.Vector(new Taf.STRING());
  this.iBrowseCount = 0;
  this.iCardType = 0;
  this.vMomentAttachment = new Taf.Vector(new HUYA.MomentAttachment());
  this.iStepOnCount = 0;
  this.iUserOpt = 0;
  this.vMomentDecoration = new Taf.Vector(new HUYA.MomentDecorationItem());
  this.iTopStatus = 0;
  this.sTraceId = "";
  this.mpServerContext = new Taf.Map(new Taf.STRING(), new Taf.STRING());
  this.mpExtInfo = new Taf.Map(new Taf.STRING(), new Taf.STRING());
  this.sServerContext = "";
};

HUYA.MomentInfo.prototype.readFrom = function (is) {
  this.lMomId = is.readInt64(0, false, this.lMomId);
  this.iType = is.readInt32(1, false, this.iType);
  this.lUid = is.readInt64(2, false, this.lUid);
  this.sNickName = is.readString(3, false, this.sNickName);
  this.sIconUrl = is.readString(4, false, this.sIconUrl);
  this.sTitle = is.readString(5, false, this.sTitle);
  this.sContent = is.readString(6, false, this.sContent);
  this.iFavorCount = is.readInt32(7, false, this.iFavorCount);
  this.iCommentCount = is.readInt32(8, false, this.iCommentCount);
  this.iShareCount = is.readInt32(9, false, this.iShareCount);
  this.vComment = is.readVector(10, false, this.vComment);
  this.iCTime = is.readInt32(11, false, this.iCTime);
  this.iStatus = is.readInt32(12, false, this.iStatus);
  this.iOpt = is.readInt32(13, false, this.iOpt);
  this.tVideoInfo = is.readStruct(14, false, this.tVideoInfo);
  this.vKeyWord = is.readVector(15, false, this.vKeyWord);
  this.iHasDraw = is.readInt32(16, false, this.iHasDraw);
  this.vCoverUrl = is.readVector(17, false, this.vCoverUrl);
  this.sHtmlDoc = is.readString(18, false, this.sHtmlDoc);
  this.vTags = is.readVector(19, false, this.vTags);
  this.vBelongPlate = is.readVector(20, false, this.vBelongPlate);
  this.iBrowseCount = is.readInt32(21, false, this.iBrowseCount);
  this.iCardType = is.readInt32(22, false, this.iCardType);
  this.vMomentAttachment = is.readVector(23, false, this.vMomentAttachment);
  this.iStepOnCount = is.readInt32(24, false, this.iStepOnCount);
  this.iUserOpt = is.readInt32(25, false, this.iUserOpt);
  this.vMomentDecoration = is.readVector(26, false, this.vMomentDecoration);
  this.iTopStatus = is.readInt32(27, false, this.iTopStatus);
  this.sTraceId = is.readString(28, false, this.sTraceId);
  this.mpServerContext = is.readMap(29, false, this.mpServerContext);
  this.mpExtInfo = is.readMap(30, false, this.mpExtInfo);
  this.sServerContext = is.readString(31, false, this.sServerContext);
};

HUYA.MomentInfo.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lMomId);
  os.writeInt32(1, this.iType);
  os.writeInt64(2, this.lUid);
  os.writeString(3, this.sNickName);
  os.writeString(4, this.sIconUrl);
  os.writeString(5, this.sTitle);
  os.writeString(6, this.sContent);
  os.writeInt32(7, this.iFavorCount);
  os.writeInt32(8, this.iCommentCount);
  os.writeInt32(9, this.iShareCount);
  os.writeVector(10, this.vComment);
  os.writeInt32(11, this.iCTime);
  os.writeInt32(12, this.iStatus);
  os.writeInt32(13, this.iOpt);
  os.writeStruct(14, this.tVideoInfo);
  os.writeVector(15, this.vKeyWord);
  os.writeInt32(16, this.iHasDraw);
  os.writeVector(17, this.vCoverUrl);
  os.writeString(18, this.sHtmlDoc);
  os.writeVector(19, this.vTags);
  os.writeVector(20, this.vBelongPlate);
  os.writeInt32(21, this.iBrowseCount);
  os.writeInt32(22, this.iCardType);
  os.writeVector(23, this.vMomentAttachment);
  os.writeInt32(24, this.iStepOnCount);
  os.writeInt32(25, this.iUserOpt);
  os.writeVector(26, this.vMomentDecoration);
  os.writeInt32(27, this.iTopStatus);
  os.writeString(28, this.sTraceId);
  os.writeMap(29, this.mpServerContext);
  os.writeMap(30, this.mpExtInfo);
  os.writeString(31, this.sServerContext);
};

HUYA.MomentInfo.prototype._clone = function () {
  return new HUYA.MomentInfo();
};
HUYA.MomentInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.CommentInfo = function () {
  this.lComId = 0;
  this.lParentId = 0;
  this.lMomId = 0;
  this.lUid = 0;
  this.sNickName = "";
  this.sIconUrl = "";
  this.sContent = "";
  this.iCTime = 0;
  this.iFavorCount = 0;
  this.iReplyCount = 0;
  this.vComment = new Taf.Vector(HUYA.CommentInfo);
  this.lReplyToComId = 0;
  this.lReplyToUid = 0;
  this.sReplyToNickName = "";
  this.iStatus = 0;
  this.iOpt = 0;
  this.iFavoredByOnwer = 0;
  this.iTopStatus = 0;
  this.vCommentAttach = new Taf.Vector(new HUYA.CommentAttach());
  this.vTags = new Taf.Vector(new Taf.STRING());
  this.vCornerMark = new Taf.Vector(new HUYA.CommentCornerMark());
  this.mpExtInfo = new Taf.Map(new Taf.STRING(), new Taf.STRING());
  this.vCommentDeco = new Taf.Vector(new HUYA.CommentDecoration());
  this.sCertSmallIcon = "";
  this.sReplyToCertSmallIcon = "";
};

HUYA.CommentInfo.prototype.readFrom = function (is) {
  this.lComId = is.readInt64(0, false, this.lComId);
  this.lParentId = is.readInt64(1, false, this.lParentId);
  this.lMomId = is.readInt64(2, false, this.lMomId);
  this.lUid = is.readInt64(3, false, this.lUid);
  this.sNickName = is.readString(4, false, this.sNickName);
  this.sIconUrl = is.readString(5, false, this.sIconUrl);
  this.sContent = is.readString(6, false, this.sContent);
  this.iCTime = is.readInt32(7, false, this.iCTime);
  this.iFavorCount = is.readInt32(8, false, this.iFavorCount);
  this.iReplyCount = is.readInt32(9, false, this.iReplyCount);
  this.vComment = is.readVector(10, false, this.vComment);
  this.lReplyToComId = is.readInt64(11, false, this.lReplyToComId);
  this.lReplyToUid = is.readInt64(12, false, this.lReplyToUid);
  this.sReplyToNickName = is.readString(13, false, this.sReplyToNickName);
  this.iStatus = is.readInt32(14, false, this.iStatus);
  this.iOpt = is.readInt32(15, false, this.iOpt);
  this.iFavoredByOnwer = is.readInt32(16, false, this.iFavoredByOnwer);
  this.iTopStatus = is.readInt32(20, false, this.iTopStatus);
  this.vCommentAttach = is.readVector(21, false, this.vCommentAttach);
  this.vTags = is.readVector(22, false, this.vTags);
  this.vCornerMark = is.readVector(23, false, this.vCornerMark);
  this.mpExtInfo = is.readMap(24, false, this.mpExtInfo);
  this.vCommentDeco = is.readVector(25, false, this.vCommentDeco);
  this.sCertSmallIcon = is.readString(26, false, this.sCertSmallIcon);
  this.sReplyToCertSmallIcon = is.readString(
    27,
    false,
    this.sReplyToCertSmallIcon
  );
};

HUYA.CommentInfo.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lComId);
  os.writeInt64(1, this.lParentId);
  os.writeInt64(2, this.lMomId);
  os.writeInt64(3, this.lUid);
  os.writeString(4, this.sNickName);
  os.writeString(5, this.sIconUrl);
  os.writeString(6, this.sContent);
  os.writeInt32(7, this.iCTime);
  os.writeInt32(8, this.iFavorCount);
  os.writeInt32(9, this.iReplyCount);
  os.writeVector(10, this.vComment);
  os.writeInt64(11, this.lReplyToComId);
  os.writeInt64(12, this.lReplyToUid);
  os.writeString(13, this.sReplyToNickName);
  os.writeInt32(14, this.iStatus);
  os.writeInt32(15, this.iOpt);
  os.writeInt32(16, this.iFavoredByOnwer);
  os.writeInt32(20, this.iTopStatus);
  os.writeVector(21, this.vCommentAttach);
  os.writeVector(22, this.vTags);
  os.writeVector(23, this.vCornerMark);
  os.writeMap(24, this.mpExtInfo);
  os.writeVector(25, this.vCommentDeco);
  os.writeString(26, this.sCertSmallIcon);
  os.writeString(27, this.sReplyToCertSmallIcon);
};

HUYA.CommentInfo.prototype._clone = function () {
  return new HUYA.CommentInfo();
};
HUYA.CommentInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.CommentInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.CommentAttach = function () {
  this.iType = 0;
  this.sContent = "";
  this.sFileMD5 = "";
  this.vAtContent = new Taf.Vector(new HUYA.MomentAtContent());
  this.iDuration = 0;
};

HUYA.CommentAttach.prototype.readFrom = function (is) {
  this.iType = is.readInt32(0, false, this.iType);
  this.sContent = is.readString(1, false, this.sContent);
  this.sFileMD5 = is.readString(2, false, this.sFileMD5);
  this.vAtContent = is.readVector(3, false, this.vAtContent);
  this.iDuration = is.readInt32(4, false, this.iDuration);
};

HUYA.CommentAttach.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iType);
  os.writeString(1, this.sContent);
  os.writeString(2, this.sFileMD5);
  os.writeVector(3, this.vAtContent);
  os.writeInt32(4, this.iDuration);
};

HUYA.CommentAttach.prototype._clone = function () {
  return new HUYA.CommentAttach();
};
HUYA.CommentAttach.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.CommentAttach.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentAtContent = function () {
  this.lAtUid = 0;
  this.sAtNick = "";
  this.iBegin = 0;
  this.iEnd = 0;
};

HUYA.MomentAtContent.prototype.readFrom = function (is) {
  this.lAtUid = is.readInt64(0, false, this.lAtUid);
  this.sAtNick = is.readString(1, false, this.sAtNick);
  this.iBegin = is.readInt32(2, false, this.iBegin);
  this.iEnd = is.readInt32(3, false, this.iEnd);
};

HUYA.MomentAtContent.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lAtUid);
  os.writeString(1, this.sAtNick);
  os.writeInt32(2, this.iBegin);
  os.writeInt32(3, this.iEnd);
};

HUYA.MomentAtContent.prototype._clone = function () {
  return new HUYA.MomentAtContent();
};
HUYA.MomentAtContent.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentAtContent.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.CommentCornerMark = function () {
  this.iId = 0;
  this.sContent = "";
};

HUYA.CommentCornerMark.prototype.readFrom = function (is) {
  this.iId = is.readInt32(0, false, this.iId);
  this.sContent = is.readString(1, false, this.sContent);
};

HUYA.CommentCornerMark.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iId);
  os.writeString(1, this.sContent);
};

HUYA.CommentCornerMark.prototype._clone = function () {
  return new HUYA.CommentCornerMark();
};
HUYA.CommentCornerMark.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.CommentCornerMark.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.CommentDecoration = function () {
  this.iType = 0;
  this.vData = new Taf.BinBuffer();
};

HUYA.CommentDecoration.prototype.readFrom = function (is) {
  this.iType = is.readInt32(0, false, this.iType);
  this.vData = is.readBytes(1, false, this.vData);
};

HUYA.CommentDecoration.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iType);
  os.writeBytes(1, this.vData);
};

HUYA.CommentDecoration.prototype._clone = function () {
  return new HUYA.CommentDecoration();
};
HUYA.CommentDecoration.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.CommentDecoration.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.VideoInfo = function () {
  this.lUid = 0;
  this.sAvatarUrl = "";
  this.sNickName = "";
  this.lVid = 0;
  this.sVideoTitle = "";
  this.sVideoCover = "";
  this.lVideoPlayNum = 0;
  this.lVideoCommentNum = 0;
  this.sVideoDuration = "";
  this.sVideoUrl = "";
  this.sVideoUploadTime = "";
  this.sVideoChannel = "";
  this.sCategory = "";
  this.vDefinitions = new Taf.Vector(new HUYA.VideoDefinition());
  this.iVideoRecommend = 0;
  this.bVideoDot = true;
  this.lVideoRank = 0;
  this.bVideoHasRanked = true;
  this.sTraceId = "";
  this.lActorUid = 0;
  this.sActorNick = "";
  this.sActorAvatarUrl = "";
  this.iExtPlayTimes = 0;
  this.sVideoBigCover = "";
  this.iCommentCount = 0;
  this.vTags = new Taf.Vector(new Taf.STRING());
  this.iVideoDirection = 0;
  this.sBriefIntroduction = "";
  this.iVideoType = 0;
  this.iFavorCount = 0;
  this.lMomId = 0;
  this.sSubTitle = "";
  this.mMiscData = new Taf.Map(new Taf.STRING(), new Taf.STRING());
  this.vRawDefinitions = new Taf.Vector(new HUYA.VideoDefinition());
  this.canPlay = 0;
  this.status = 0;
  this.vPortraitCovers = new Taf.Vector(new HUYA.PortraitCover());
};

HUYA.VideoInfo.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.sAvatarUrl = is.readString(1, false, this.sAvatarUrl);
  this.sNickName = is.readString(2, false, this.sNickName);
  this.lVid = is.readInt64(3, false, this.lVid);
  this.sVideoTitle = is.readString(4, false, this.sVideoTitle);
  this.sVideoCover = is.readString(5, false, this.sVideoCover);
  this.lVideoPlayNum = is.readInt64(6, false, this.lVideoPlayNum);
  this.lVideoCommentNum = is.readInt64(7, false, this.lVideoCommentNum);
  this.sVideoDuration = is.readString(8, false, this.sVideoDuration);
  this.sVideoUrl = is.readString(9, false, this.sVideoUrl);
  this.sVideoUploadTime = is.readString(10, false, this.sVideoUploadTime);
  this.sVideoChannel = is.readString(11, false, this.sVideoChannel);
  this.sCategory = is.readString(12, false, this.sCategory);
  this.vDefinitions = is.readVector(13, false, this.vDefinitions);
  this.iVideoRecommend = is.readInt32(14, false, this.iVideoRecommend);
  this.bVideoDot = is.readBoolean(15, false, this.bVideoDot);
  this.lVideoRank = is.readInt64(16, false, this.lVideoRank);
  this.bVideoHasRanked = is.readBoolean(17, false, this.bVideoHasRanked);
  this.sTraceId = is.readString(18, false, this.sTraceId);
  this.lActorUid = is.readInt64(19, false, this.lActorUid);
  this.sActorNick = is.readString(20, false, this.sActorNick);
  this.sActorAvatarUrl = is.readString(21, false, this.sActorAvatarUrl);
  this.iExtPlayTimes = is.readInt32(22, false, this.iExtPlayTimes);
  this.sVideoBigCover = is.readString(23, false, this.sVideoBigCover);
  this.iCommentCount = is.readInt32(24, false, this.iCommentCount);
  this.vTags = is.readVector(25, false, this.vTags);
  this.iVideoDirection = is.readInt32(26, false, this.iVideoDirection);
  this.sBriefIntroduction = is.readString(27, false, this.sBriefIntroduction);
  this.iVideoType = is.readInt32(28, false, this.iVideoType);
  this.iFavorCount = is.readInt32(29, false, this.iFavorCount);
  this.lMomId = is.readInt64(30, false, this.lMomId);
  this.sSubTitle = is.readString(31, false, this.sSubTitle);
  this.mMiscData = is.readMap(32, false, this.mMiscData);
  this.vRawDefinitions = is.readVector(33, false, this.vRawDefinitions);
  this.canPlay = is.readInt32(34, false, this.canPlay);
  this.status = is.readInt32(35, false, this.status);
  this.vPortraitCovers = is.readVector(36, false, this.vPortraitCovers);
};

HUYA.VideoInfo.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid);
  os.writeString(1, this.sAvatarUrl);
  os.writeString(2, this.sNickName);
  os.writeInt64(3, this.lVid);
  os.writeString(4, this.sVideoTitle);
  os.writeString(5, this.sVideoCover);
  os.writeInt64(6, this.lVideoPlayNum);
  os.writeInt64(7, this.lVideoCommentNum);
  os.writeString(8, this.sVideoDuration);
  os.writeString(9, this.sVideoUrl);
  os.writeString(10, this.sVideoUploadTime);
  os.writeString(11, this.sVideoChannel);
  os.writeString(12, this.sCategory);
  os.writeVector(13, this.vDefinitions);
  os.writeInt32(14, this.iVideoRecommend);
  os.writeBoolean(15, this.bVideoDot);
  os.writeInt64(16, this.lVideoRank);
  os.writeBoolean(17, this.bVideoHasRanked);
  os.writeString(18, this.sTraceId);
  os.writeInt64(19, this.lActorUid);
  os.writeString(20, this.sActorNick);
  os.writeString(21, this.sActorAvatarUrl);
  os.writeInt32(22, this.iExtPlayTimes);
  os.writeString(23, this.sVideoBigCover);
  os.writeInt32(24, this.iCommentCount);
  os.writeVector(25, this.vTags);
  os.writeInt32(26, this.iVideoDirection);
  os.writeString(27, this.sBriefIntroduction);
  os.writeInt32(28, this.iVideoType);
  os.writeInt32(29, this.iFavorCount);
  os.writeInt64(30, this.lMomId);
  os.writeString(31, this.sSubTitle);
  os.writeMap(32, this.mMiscData);
  os.writeVector(33, this.vRawDefinitions);
  os.writeInt32(34, this.canPlay);
  os.writeInt32(35, this.status);
  os.writeVector(36, this.vPortraitCovers);
};

HUYA.VideoInfo.prototype._clone = function () {
  return new HUYA.VideoInfo();
};
HUYA.VideoInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.VideoInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.VideoDefinition = function () {
  this.sSize = "";
  this.sWidth = "";
  this.sHeight = "";
  this.sDefinition = "";
  this.sUrl = "";
  this.sM3u8 = "";
  this.sDefName = "";
  this.sTs1Url = "";
  this.sTs1Offset = "";
  this.iLineIndex = 0;
  this.iBitRate = 0;
  this.mpExtraParam = new Taf.Map(new Taf.STRING(), new Taf.STRING());
  this.vStreamInfo = new Taf.Vector(new HUYA.VideoStreamInfo());
  this.sCodec = "";
  this.sFormat = "";
  this.sDuration = "";
  this.iM3u8LineIndex = 0;
};

HUYA.VideoDefinition.prototype.readFrom = function (is) {
  this.sSize = is.readString(0, false, this.sSize);
  this.sWidth = is.readString(1, false, this.sWidth);
  this.sHeight = is.readString(2, false, this.sHeight);
  this.sDefinition = is.readString(3, false, this.sDefinition);
  this.sUrl = is.readString(4, false, this.sUrl);
  this.sM3u8 = is.readString(5, false, this.sM3u8);
  this.sDefName = is.readString(6, false, this.sDefName);
  this.sTs1Url = is.readString(7, false, this.sTs1Url);
  this.sTs1Offset = is.readString(8, false, this.sTs1Offset);
  this.iLineIndex = is.readInt32(9, false, this.iLineIndex);
  this.iBitRate = is.readInt32(10, false, this.iBitRate);
  this.mpExtraParam = is.readMap(11, false, this.mpExtraParam);
  this.vStreamInfo = is.readVector(12, false, this.vStreamInfo);
  this.sCodec = is.readString(13, false, this.sCodec);
  this.sFormat = is.readString(14, false, this.sFormat);
  this.sDuration = is.readString(15, false, this.sDuration);
  this.iM3u8LineIndex = is.readInt32(16, false, this.iM3u8LineIndex);
};

HUYA.VideoDefinition.prototype.writeTo = function (os) {
  os.writeString(0, this.sSize);
  os.writeString(1, this.sWidth);
  os.writeString(2, this.sHeight);
  os.writeString(3, this.sDefinition);
  os.writeString(4, this.sUrl);
  os.writeString(5, this.sM3u8);
  os.writeString(6, this.sDefName);
  os.writeString(7, this.sTs1Url);
  os.writeString(8, this.sTs1Offset);
  os.writeInt32(9, this.iLineIndex);
  os.writeInt32(10, this.iBitRate);
  os.writeMap(11, this.mpExtraParam);
  os.writeVector(12, this.vStreamInfo);
  os.writeString(13, this.sCodec);
  os.writeString(14, this.sFormat);
  os.writeString(15, this.sDuration);
  os.writeInt32(16, this.iM3u8LineIndex);
};

HUYA.VideoDefinition.prototype._clone = function () {
  return new HUYA.VideoDefinition();
};
HUYA.VideoDefinition.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.VideoDefinition.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.VideoStreamInfo = function () {
  this.sSize = "";
  this.sWidth = "";
  this.sHeight = "";
  this.sFormat = "";
  this.sUrl = "";
  this.sM3u8 = "";
  this.sTs1Url = "";
  this.sTs1Offset = "";
  this.iBitRate = 0;
  this.sCodec = "";
  this.mpExtraParam = new Taf.Map(new Taf.STRING(), new Taf.STRING());
  this.iLineIndex = 0;
  this.iM3u8LineIndex = 0;
};

HUYA.VideoStreamInfo.prototype.readFrom = function (is) {
  this.sSize = is.readString(0, false, this.sSize);
  this.sWidth = is.readString(1, false, this.sWidth);
  this.sHeight = is.readString(2, false, this.sHeight);
  this.sFormat = is.readString(3, false, this.sFormat);
  this.sUrl = is.readString(4, false, this.sUrl);
  this.sM3u8 = is.readString(5, false, this.sM3u8);
  this.sTs1Url = is.readString(6, false, this.sTs1Url);
  this.sTs1Offset = is.readString(7, false, this.sTs1Offset);
  this.iBitRate = is.readInt32(8, false, this.iBitRate);
  this.sCodec = is.readString(9, false, this.sCodec);
  this.mpExtraParam = is.readMap(10, false, this.mpExtraParam);
  this.iLineIndex = is.readInt32(11, false, this.iLineIndex);
  this.iM3u8LineIndex = is.readInt32(12, false, this.iM3u8LineIndex);
};

HUYA.VideoStreamInfo.prototype.writeTo = function (os) {
  os.writeString(0, this.sSize);
  os.writeString(1, this.sWidth);
  os.writeString(2, this.sHeight);
  os.writeString(3, this.sFormat);
  os.writeString(4, this.sUrl);
  os.writeString(5, this.sM3u8);
  os.writeString(6, this.sTs1Url);
  os.writeString(7, this.sTs1Offset);
  os.writeInt32(8, this.iBitRate);
  os.writeString(9, this.sCodec);
  os.writeMap(10, this.mpExtraParam);
  os.writeInt32(11, this.iLineIndex);
  os.writeInt32(12, this.iM3u8LineIndex);
};

HUYA.VideoStreamInfo.prototype._clone = function () {
  return new HUYA.VideoStreamInfo();
};
HUYA.VideoStreamInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.VideoStreamInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.PortraitCover = function () {
  this.seq = 0;
  this.width = 0;
  this.height = 0;
  this.url = "";
  this.similarGroup = "";
};

HUYA.PortraitCover.prototype.readFrom = function (is) {
  this.seq = is.readInt32(0, false, this.seq);
  this.width = is.readInt32(1, false, this.width);
  this.height = is.readInt32(2, false, this.height);
  this.url = is.readString(3, false, this.url);
  this.similarGroup = is.readString(4, false, this.similarGroup);
};

HUYA.PortraitCover.prototype.writeTo = function (os) {
  os.writeInt32(0, this.seq);
  os.writeInt32(1, this.width);
  os.writeInt32(2, this.height);
  os.writeString(3, this.url);
  os.writeString(4, this.similarGroup);
};

HUYA.PortraitCover.prototype._clone = function () {
  return new HUYA.PortraitCover();
};
HUYA.PortraitCover.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.PortraitCover.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentAttachment = function () {
  this.iType = 0;
  this.sContent = "";
  this.sUrl = new Taf.Vector(new HUYA.MomentUrl());
  this.iDataType = 0;
  this.sData = new Taf.BinBuffer();
  this.vAtContent = new Taf.Vector(new HUYA.MomentAtContent());
  this.vAttachLink = new Taf.Vector(new Taf.STRING());
  this.sVoteId = "";
  this.lVideoId = 0;
  this.vAction = new Taf.Vector(new HUYA.MomentUrl());
  this.tInfo = new HUYA.MomentGoodsInfo();
  this.tForwardedMoment = new HUYA.ForwardedMomAttach();
  this.tVote = new HUYA.MomentVoteInfo();
  this.tVideoCollection = new HUYA.MomentVideoCollectionAttach();
  this.vGuessInfo = new Taf.Vector(new HUYA.MomentGuessInfoAttach());
  this.vCommonScoreInfo = new Taf.Vector(new HUYA.MomentCommonScoreInfo());
  this.vCommonScoreObject = new Taf.Vector(
    new HUYA.MomentAttachCommonScoreObject()
  );
};

HUYA.MomentAttachment.prototype.readFrom = function (is) {
  this.iType = is.readInt32(0, false, this.iType);
  this.sContent = is.readString(1, false, this.sContent);
  this.sUrl = is.readVector(2, false, this.sUrl);
  this.iDataType = is.readInt32(3, false, this.iDataType);
  this.sData = is.readBytes(4, false, this.sData);
  this.vAtContent = is.readVector(5, false, this.vAtContent);
  this.vAttachLink = is.readVector(6, false, this.vAttachLink);
  this.sVoteId = is.readString(7, false, this.sVoteId);
  this.lVideoId = is.readInt64(8, false, this.lVideoId);
  this.vAction = is.readVector(9, false, this.vAction);
  this.tInfo = is.readStruct(10, false, this.tInfo);
  this.tForwardedMoment = is.readStruct(12, false, this.tForwardedMoment);
  this.tVote = is.readStruct(13, false, this.tVote);
  this.tVideoCollection = is.readStruct(14, false, this.tVideoCollection);
  this.vGuessInfo = is.readVector(15, false, this.vGuessInfo);
  this.vCommonScoreInfo = is.readVector(16, false, this.vCommonScoreInfo);
  this.vCommonScoreObject = is.readVector(17, false, this.vCommonScoreObject);
};

HUYA.MomentAttachment.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iType);
  os.writeString(1, this.sContent);
  os.writeVector(2, this.sUrl);
  os.writeInt32(3, this.iDataType);
  os.writeBytes(4, this.sData);
  os.writeVector(5, this.vAtContent);
  os.writeVector(6, this.vAttachLink);
  os.writeString(7, this.sVoteId);
  os.writeInt64(8, this.lVideoId);
  os.writeVector(9, this.vAction);
  os.writeStruct(10, this.tInfo);
  os.writeStruct(12, this.tForwardedMoment);
  os.writeStruct(13, this.tVote);
  os.writeStruct(14, this.tVideoCollection);
  os.writeVector(15, this.vGuessInfo);
  os.writeVector(16, this.vCommonScoreInfo);
  os.writeVector(17, this.vCommonScoreObject);
};

HUYA.MomentAttachment.prototype._clone = function () {
  return new HUYA.MomentAttachment();
};
HUYA.MomentAttachment.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentAttachment.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentUrl = function () {
  this.sCover = "";
  this.sUrl = "";
  this.iDirection = 0;
  this.iDuration = 0;
  this.sFileMD5 = "";
  this.sText = "";
  this.iIsIllegal = 0;
  this.iCoverWidth = 0;
  this.iCoverHeight = 0;
  this.tOriPicMeta = new HUYA.MomentOriginalPicMetaData();
};

HUYA.MomentUrl.prototype.readFrom = function (is) {
  this.sCover = is.readString(0, false, this.sCover);
  this.sUrl = is.readString(1, false, this.sUrl);
  this.iDirection = is.readInt32(2, false, this.iDirection);
  this.iDuration = is.readInt32(3, false, this.iDuration);
  this.sFileMD5 = is.readString(4, false, this.sFileMD5);
  this.sText = is.readString(5, false, this.sText);
  this.iIsIllegal = is.readInt32(6, false, this.iIsIllegal);
  this.iCoverWidth = is.readInt32(7, false, this.iCoverWidth);
  this.iCoverHeight = is.readInt32(9, false, this.iCoverHeight);
  this.tOriPicMeta = is.readStruct(10, false, this.tOriPicMeta);
};

HUYA.MomentUrl.prototype.writeTo = function (os) {
  os.writeString(0, this.sCover);
  os.writeString(1, this.sUrl);
  os.writeInt32(2, this.iDirection);
  os.writeInt32(3, this.iDuration);
  os.writeString(4, this.sFileMD5);
  os.writeString(5, this.sText);
  os.writeInt32(6, this.iIsIllegal);
  os.writeInt32(7, this.iCoverWidth);
  os.writeInt32(9, this.iCoverHeight);
  os.writeStruct(10, this.tOriPicMeta);
};

HUYA.MomentUrl.prototype._clone = function () {
  return new HUYA.MomentUrl();
};
HUYA.MomentUrl.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentUrl.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentOriginalPicMetaData = function () {
  this.iWidth = 0;
  this.iHeight = 0;
};

HUYA.MomentOriginalPicMetaData.prototype.readFrom = function (is) {
  this.iWidth = is.readInt32(0, false, this.iWidth);
  this.iHeight = is.readInt32(1, false, this.iHeight);
};

HUYA.MomentOriginalPicMetaData.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iWidth);
  os.writeInt32(1, this.iHeight);
};

HUYA.MomentOriginalPicMetaData.prototype._clone = function () {
  return new HUYA.MomentOriginalPicMetaData();
};
HUYA.MomentOriginalPicMetaData.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentOriginalPicMetaData.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentGoodsInfo = function () {
  this.vDetail = new Taf.Vector(new HUYA.GoodsDetail());
};

HUYA.MomentGoodsInfo.prototype.readFrom = function (is) {
  this.vDetail = is.readVector(0, false, this.vDetail);
};

HUYA.MomentGoodsInfo.prototype.writeTo = function (os) {
  os.writeVector(0, this.vDetail);
};

HUYA.MomentGoodsInfo.prototype._clone = function () {
  return new HUYA.MomentGoodsInfo();
};
HUYA.MomentGoodsInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentGoodsInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.GoodsDetail = function () {
  this.spuId = "";
  this.platform = "";
  this.name = "";
  this.imageUrl = "";
  this.minPrice = 0;
  this.maxPrice = 0;
  this.marketPrice = 0;
  this.sAction = "";
};

HUYA.GoodsDetail.prototype.readFrom = function (is) {
  this.spuId = is.readString(0, false, this.spuId);
  this.platform = is.readString(1, false, this.platform);
  this.name = is.readString(2, false, this.name);
  this.imageUrl = is.readString(3, false, this.imageUrl);
  this.minPrice = is.readInt64(4, false, this.minPrice);
  this.maxPrice = is.readInt64(5, false, this.maxPrice);
  this.marketPrice = is.readInt64(6, false, this.marketPrice);
  this.sAction = is.readString(7, false, this.sAction);
};

HUYA.GoodsDetail.prototype.writeTo = function (os) {
  os.writeString(0, this.spuId);
  os.writeString(1, this.platform);
  os.writeString(2, this.name);
  os.writeString(3, this.imageUrl);
  os.writeInt64(4, this.minPrice);
  os.writeInt64(5, this.maxPrice);
  os.writeInt64(6, this.marketPrice);
  os.writeString(7, this.sAction);
};

HUYA.GoodsDetail.prototype._clone = function () {
  return new HUYA.GoodsDetail();
};
HUYA.GoodsDetail.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.GoodsDetail.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.ForwardedMomAttach = function () {
  this.lForwardedMomId = 0;
  this.vForwardMoment = new Taf.Vector(new HUYA.ForwardedMomentAbstract());
  this.vOriginMomentData = new Taf.BinBuffer();
};

HUYA.ForwardedMomAttach.prototype.readFrom = function (is) {
  this.lForwardedMomId = is.readInt64(0, false, this.lForwardedMomId);
  this.vForwardMoment = is.readVector(1, false, this.vForwardMoment);
  this.vOriginMomentData = is.readBytes(2, false, this.vOriginMomentData);
};

HUYA.ForwardedMomAttach.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lForwardedMomId);
  os.writeVector(1, this.vForwardMoment);
  os.writeBytes(2, this.vOriginMomentData);
};

HUYA.ForwardedMomAttach.prototype._clone = function () {
  return new HUYA.ForwardedMomAttach();
};
HUYA.ForwardedMomAttach.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.ForwardedMomAttach.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.ForwardedMomentAbstract = function () {
  this.lMomId = 0;
  this.lAuthorUid = 0;
  this.sAuthorNick = "";
  this.sTitle = "";
  this.iHasPicture = 0;
};

HUYA.ForwardedMomentAbstract.prototype.readFrom = function (is) {
  this.lMomId = is.readInt64(0, false, this.lMomId);
  this.lAuthorUid = is.readInt64(1, false, this.lAuthorUid);
  this.sAuthorNick = is.readString(2, false, this.sAuthorNick);
  this.sTitle = is.readString(3, false, this.sTitle);
  this.iHasPicture = is.readInt32(4, false, this.iHasPicture);
};

HUYA.ForwardedMomentAbstract.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lMomId);
  os.writeInt64(1, this.lAuthorUid);
  os.writeString(2, this.sAuthorNick);
  os.writeString(3, this.sTitle);
  os.writeInt32(4, this.iHasPicture);
};

HUYA.ForwardedMomentAbstract.prototype._clone = function () {
  return new HUYA.ForwardedMomentAbstract();
};
HUYA.ForwardedMomentAbstract.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.ForwardedMomentAbstract.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentVoteInfo = function () {
  this.sVoteId = "";
  this.sVoteTitle = "";
  this.vVoteOption = new Taf.Vector(new HUYA.MomentVoteOption());
  this.mItemCount = new Taf.Map(new Taf.STRING(), new Taf.INT64());
  this.vUserChoose = new Taf.Vector(new Taf.STRING());
  this.iVoteShowStyle = 0;
  this.lBeginTime = 0;
  this.lEndTime = 0;
};

HUYA.MomentVoteInfo.prototype.readFrom = function (is) {
  this.sVoteId = is.readString(0, false, this.sVoteId);
  this.sVoteTitle = is.readString(1, false, this.sVoteTitle);
  this.vVoteOption = is.readVector(2, false, this.vVoteOption);
  this.mItemCount = is.readMap(3, false, this.mItemCount);
  this.vUserChoose = is.readVector(4, false, this.vUserChoose);
  this.iVoteShowStyle = is.readInt32(5, false, this.iVoteShowStyle);
  this.lBeginTime = is.readInt64(6, false, this.lBeginTime);
  this.lEndTime = is.readInt64(7, false, this.lEndTime);
};

HUYA.MomentVoteInfo.prototype.writeTo = function (os) {
  os.writeString(0, this.sVoteId);
  os.writeString(1, this.sVoteTitle);
  os.writeVector(2, this.vVoteOption);
  os.writeMap(3, this.mItemCount);
  os.writeVector(4, this.vUserChoose);
  os.writeInt32(5, this.iVoteShowStyle);
  os.writeInt64(6, this.lBeginTime);
  os.writeInt64(7, this.lEndTime);
};

HUYA.MomentVoteInfo.prototype._clone = function () {
  return new HUYA.MomentVoteInfo();
};
HUYA.MomentVoteInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentVoteInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentVoteOption = function () {
  this.sOptionId = "";
  this.sTitle = "";
  this.sPicUrl = "";
};

HUYA.MomentVoteOption.prototype.readFrom = function (is) {
  this.sOptionId = is.readString(0, false, this.sOptionId);
  this.sTitle = is.readString(1, false, this.sTitle);
  this.sPicUrl = is.readString(2, false, this.sPicUrl);
};

HUYA.MomentVoteOption.prototype.writeTo = function (os) {
  os.writeString(0, this.sOptionId);
  os.writeString(1, this.sTitle);
  os.writeString(2, this.sPicUrl);
};

HUYA.MomentVoteOption.prototype._clone = function () {
  return new HUYA.MomentVoteOption();
};
HUYA.MomentVoteOption.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentVoteOption.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentVideoCollectionAttach = function () {
  this.iCollectionId = 0;
  this.iNo = 0;
  this.lFirstVid = 0;
};

HUYA.MomentVideoCollectionAttach.prototype.readFrom = function (is) {
  this.iCollectionId = is.readInt32(0, false, this.iCollectionId);
  this.iNo = is.readInt32(1, false, this.iNo);
  this.lFirstVid = is.readInt64(2, false, this.lFirstVid);
};

HUYA.MomentVideoCollectionAttach.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iCollectionId);
  os.writeInt32(1, this.iNo);
  os.writeInt64(2, this.lFirstVid);
};

HUYA.MomentVideoCollectionAttach.prototype._clone = function () {
  return new HUYA.MomentVideoCollectionAttach();
};
HUYA.MomentVideoCollectionAttach.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentVideoCollectionAttach.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentGuessInfoAttach = function () {
  this.vGuessInfo = new Taf.BinBuffer();
  this.tMatchGuessCardInfo = new HUYA.MatchGuessCardInfo();
};

HUYA.MomentGuessInfoAttach.prototype.readFrom = function (is) {
  this.vGuessInfo = is.readBytes(1, false, this.vGuessInfo);
  this.tMatchGuessCardInfo = is.readStruct(2, false, this.tMatchGuessCardInfo);
};

HUYA.MomentGuessInfoAttach.prototype.writeTo = function (os) {
  os.writeBytes(1, this.vGuessInfo);
  os.writeStruct(2, this.tMatchGuessCardInfo);
};

HUYA.MomentGuessInfoAttach.prototype._clone = function () {
  return new HUYA.MomentGuessInfoAttach();
};
HUYA.MomentGuessInfoAttach.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentGuessInfoAttach.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MatchGuessCardInfo = function () {
  this.iScheduleId = 0;
  this.sScheduleName = "";
  this.lBeginTime = 0;
  this.lEndTime = 0;
  this.vTeam = new Taf.Vector(new HUYA.MatchGuessCardTeamInfo());
  this.sJumpUrl = "";
  this.iMatchId = 0;
  this.sScheduleDesc = "";
};

HUYA.MatchGuessCardInfo.prototype.readFrom = function (is) {
  this.iScheduleId = is.readInt32(0, false, this.iScheduleId);
  this.sScheduleName = is.readString(1, false, this.sScheduleName);
  this.lBeginTime = is.readInt64(2, false, this.lBeginTime);
  this.lEndTime = is.readInt64(3, false, this.lEndTime);
  this.vTeam = is.readVector(4, false, this.vTeam);
  this.sJumpUrl = is.readString(5, false, this.sJumpUrl);
  this.iMatchId = is.readInt32(6, false, this.iMatchId);
  this.sScheduleDesc = is.readString(7, false, this.sScheduleDesc);
};

HUYA.MatchGuessCardInfo.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iScheduleId);
  os.writeString(1, this.sScheduleName);
  os.writeInt64(2, this.lBeginTime);
  os.writeInt64(3, this.lEndTime);
  os.writeVector(4, this.vTeam);
  os.writeString(5, this.sJumpUrl);
  os.writeInt32(6, this.iMatchId);
  os.writeString(7, this.sScheduleDesc);
};

HUYA.MatchGuessCardInfo.prototype._clone = function () {
  return new HUYA.MatchGuessCardInfo();
};
HUYA.MatchGuessCardInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MatchGuessCardInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MatchGuessCardTeamInfo = function () {
  this.iTeamId = 0;
  this.sTeamName = "";
  this.sTeamLogo = "";
  this.iScore = 0;
};

HUYA.MatchGuessCardTeamInfo.prototype.readFrom = function (is) {
  this.iTeamId = is.readInt32(0, false, this.iTeamId);
  this.sTeamName = is.readString(1, false, this.sTeamName);
  this.sTeamLogo = is.readString(2, false, this.sTeamLogo);
  this.iScore = is.readInt32(3, false, this.iScore);
};

HUYA.MatchGuessCardTeamInfo.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iTeamId);
  os.writeString(1, this.sTeamName);
  os.writeString(2, this.sTeamLogo);
  os.writeInt32(3, this.iScore);
};

HUYA.MatchGuessCardTeamInfo.prototype._clone = function () {
  return new HUYA.MatchGuessCardTeamInfo();
};
HUYA.MatchGuessCardTeamInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MatchGuessCardTeamInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentCommonScoreInfo = function () {
  this.lObjListId = 0;
};

HUYA.MomentCommonScoreInfo.prototype.readFrom = function (is) {
  this.lObjListId = is.readInt64(0, false, this.lObjListId);
};

HUYA.MomentCommonScoreInfo.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lObjListId);
};

HUYA.MomentCommonScoreInfo.prototype._clone = function () {
  return new HUYA.MomentCommonScoreInfo();
};
HUYA.MomentCommonScoreInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentCommonScoreInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentAttachCommonScoreObject = function () {
  this.lObjId = 0;
};

HUYA.MomentAttachCommonScoreObject.prototype.readFrom = function (is) {
  this.lObjId = is.readInt64(0, false, this.lObjId);
};

HUYA.MomentAttachCommonScoreObject.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lObjId);
};

HUYA.MomentAttachCommonScoreObject.prototype._clone = function () {
  return new HUYA.MomentAttachCommonScoreObject();
};
HUYA.MomentAttachCommonScoreObject.prototype._write = function (
  os,
  tag,
  value
) {
  os.writeStruct(tag, value);
};
HUYA.MomentAttachCommonScoreObject.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentDecorationItem = function () {
  this.iType = 0;
  this.vData = new Taf.BinBuffer();
};

HUYA.MomentDecorationItem.prototype.readFrom = function (is) {
  this.iType = is.readInt32(0, false, this.iType);
  this.vData = is.readBytes(1, false, this.vData);
};

HUYA.MomentDecorationItem.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iType);
  os.writeBytes(1, this.vData);
};

HUYA.MomentDecorationItem.prototype._clone = function () {
  return new HUYA.MomentDecorationItem();
};
HUYA.MomentDecorationItem.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentDecorationItem.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.UserBase = function () {
  this.lUid = 0;
  this.sNickName = "";
  this.sAvatarUrl = "";
  this.iGender = 0;
  this.lYYId = 0;
  this.iCertified = 0;
  this.iSubscribedCount = 0;
  this.iSubscribeToCount = 0;
  this.iUserLevel = 0;
  this.lUserExp = 0;
  this.iBirthday = 0;
  this.sSign = "";
  this.sArea = "";
  this.sLocation = "";
  this.sRegisterTime = "";
  this.iFreezeTime = 0;
  this.iBindPhone = 0;
  this.sHuyaId = "";
  this.iModifyNickChannel = 0;
  this.iLogoutStatus = 0;
  this.lUserType = 0;
};

HUYA.UserBase.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.sNickName = is.readString(1, false, this.sNickName);
  this.sAvatarUrl = is.readString(2, false, this.sAvatarUrl);
  this.iGender = is.readInt32(3, false, this.iGender);
  this.lYYId = is.readInt64(4, false, this.lYYId);
  this.iCertified = is.readInt32(5, false, this.iCertified);
  this.iSubscribedCount = is.readInt32(6, false, this.iSubscribedCount);
  this.iSubscribeToCount = is.readInt32(7, false, this.iSubscribeToCount);
  this.iUserLevel = is.readInt32(8, false, this.iUserLevel);
  this.lUserExp = is.readInt64(9, false, this.lUserExp);
  this.iBirthday = is.readInt32(10, false, this.iBirthday);
  this.sSign = is.readString(11, false, this.sSign);
  this.sArea = is.readString(12, false, this.sArea);
  this.sLocation = is.readString(13, false, this.sLocation);
  this.sRegisterTime = is.readString(14, false, this.sRegisterTime);
  this.iFreezeTime = is.readInt32(15, false, this.iFreezeTime);
  this.iBindPhone = is.readInt32(16, false, this.iBindPhone);
  this.sHuyaId = is.readString(17, false, this.sHuyaId);
  this.iModifyNickChannel = is.readInt32(18, false, this.iModifyNickChannel);
  this.iLogoutStatus = is.readInt32(20, false, this.iLogoutStatus);
  this.lUserType = is.readInt64(21, false, this.lUserType);
};

HUYA.UserBase.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid);
  os.writeString(1, this.sNickName);
  os.writeString(2, this.sAvatarUrl);
  os.writeInt32(3, this.iGender);
  os.writeInt64(4, this.lYYId);
  os.writeInt32(5, this.iCertified);
  os.writeInt32(6, this.iSubscribedCount);
  os.writeInt32(7, this.iSubscribeToCount);
  os.writeInt32(8, this.iUserLevel);
  os.writeInt64(9, this.lUserExp);
  os.writeInt32(10, this.iBirthday);
  os.writeString(11, this.sSign);
  os.writeString(12, this.sArea);
  os.writeString(13, this.sLocation);
  os.writeString(14, this.sRegisterTime);
  os.writeInt32(15, this.iFreezeTime);
  os.writeInt32(16, this.iBindPhone);
  os.writeString(17, this.sHuyaId);
  os.writeInt32(18, this.iModifyNickChannel);
  os.writeInt32(20, this.iLogoutStatus);
  os.writeInt64(21, this.lUserType);
};

HUYA.UserBase.prototype._clone = function () {
  return new HUYA.UserBase();
};
HUYA.UserBase.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.UserBase.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GameAdInfo = function () {
  this.thirdpartyUrl = "";
  this.adStatus = 0;
};

GameRelease.GameAdInfo.prototype.readFrom = function (is) {
  this.thirdpartyUrl = is.readString(0, false, this.thirdpartyUrl);
  this.adStatus = is.readInt32(3, false, this.adStatus);
};

GameRelease.GameAdInfo.prototype.writeTo = function (os) {
  os.writeString(0, this.thirdpartyUrl);
  os.writeInt32(3, this.adStatus);
};

GameRelease.GameAdInfo.prototype._clone = function () {
  return new GameRelease.GameAdInfo();
};
GameRelease.GameAdInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GameAdInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

GameRelease.GameExtraInfoShow = function () {
  this.showQqGroup = 0;
  this.adrQqGroupTag = "";
  this.iosQqGroupTag = "";
  this.themeBgImg = "";
  this.themeBgColor = "";
  this.firstReleaseTime = 0;
};

GameRelease.GameExtraInfoShow.prototype.readFrom = function (is) {
  this.showQqGroup = is.readInt32(0, false, this.showQqGroup);
  this.adrQqGroupTag = is.readString(1, false, this.adrQqGroupTag);
  this.iosQqGroupTag = is.readString(2, false, this.iosQqGroupTag);
  this.themeBgImg = is.readString(3, false, this.themeBgImg);
  this.themeBgColor = is.readString(4, false, this.themeBgColor);
  this.firstReleaseTime = is.readInt64(5, false, this.firstReleaseTime);
};

GameRelease.GameExtraInfoShow.prototype.writeTo = function (os) {
  os.writeInt32(0, this.showQqGroup);
  os.writeString(1, this.adrQqGroupTag);
  os.writeString(2, this.iosQqGroupTag);
  os.writeString(3, this.themeBgImg);
  os.writeString(4, this.themeBgColor);
  os.writeInt64(5, this.firstReleaseTime);
};

GameRelease.GameExtraInfoShow.prototype._clone = function () {
  return new GameRelease.GameExtraInfoShow();
};
GameRelease.GameExtraInfoShow.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
GameRelease.GameExtraInfoShow.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};
